/* lua.js generated code undefined */

ParticleAnimationConfig = table()
ParticleAnimationConfig.SStickFlakeFixPosConfig = table(
    [0, table([1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "sstick_001.png",
                    "sstick_002.png",
                    "sstick_003.png",
                    "sstick_004.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    78,
                    385,
                    0.1,
                    600,
                    785,
                    1550,
                    75,
                    10,
                    1,
                    1
                )]
            )], [1, "random", table([1, "plists", table(
                    "sstick_005.png",
                    "sstick_007.png",
                    "sstick_008.png"
                )], [1, "other", table(
                    12,
                    57,
                    228,
                    0.8,
                    1.5,
                    0.21,
                    314,
                    648,
                    1550,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])])],
    [0, table([1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "sstick_001.png",
                    "sstick_002.png",
                    "sstick_003.png",
                    "sstick_004.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    78,
                    385,
                    0.1,
                    600,
                    785,
                    1550,
                    75,
                    10,
                    1,
                    1
                )]
            )], [1, "random", table([1, "plists", table(
                    "sstick_005.png",
                    "sstick_007.png",
                    "sstick_008.png"
                )], [1, "other", table(
                    12,
                    57,
                    228,
                    0.8,
                    1.5,
                    0.21,
                    314,
                    648,
                    1550,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])])],
    [0, table([1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "sstick_001.png",
                    "sstick_002.png",
                    "sstick_003.png",
                    "sstick_004.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    78,
                    385,
                    0.1,
                    600,
                    785,
                    1550,
                    75,
                    10,
                    1,
                    1
                )]
            )], [1, "random", table([1, "plists", table(
                    "sstick_005.png",
                    "sstick_007.png",
                    "sstick_008.png"
                )], [1, "other", table(
                    12,
                    57,
                    228,
                    0.8,
                    1.5,
                    0.21,
                    314,
                    648,
                    1550,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])])],
    [0, table([1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "sstick_001.png",
                    "sstick_002.png",
                    "sstick_003.png",
                    "sstick_004.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    78,
                    385,
                    0.1,
                    600,
                    785,
                    1550,
                    75,
                    10,
                    1,
                    1
                )]
            )], [1, "random", table([1, "plists", table(
                    "sstick_005.png",
                    "sstick_007.png",
                    "sstick_008.png"
                )], [1, "other", table(
                    12,
                    57,
                    228,
                    0.8,
                    1.5,
                    0.21,
                    314,
                    648,
                    1550,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])])]
)
ParticleAnimationConfig.SSboxFlakeFixPosConfig = table(
    [0, table([1, 2, table([1, "fix", table(
                [1, "plists", table("ssbox_1_12.png")],
                [1, "pos", table([0, cc.p(-25, 35)])],
                [1, "angle", table([0, cc.p(45, 135)])],
                [1, "other", table(
                    271,
                    326,
                    0.23,
                    110,
                    220,
                    1500,
                    75,
                    10,
                    1.5,
                    1.5
                )]
            )], [1, "random", table([1, "plists", table(
                    "ssbox_1_3.png",
                    "ssbox_1_5.png",
                    "ssbox_1_9.png",
                    "ssbox_1_8.png",
                    "ssbox_1_10.png",
                    "ssbox_1_11.png",
                    "ssbox_2_2.png",
                    "ssbox_2_3.png",
                    "ssbox_2_4.png",
                    "ssbox_2_5.png",
                    "ssbox_2_6.png",
                    "ssbox_2_7.png"
                )], [1, "other", table(
                    12,
                    57,
                    228,
                    0.8,
                    1,
                    0.32,
                    314,
                    648,
                    1600,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])], [1, 1, table([1, "fix", table(
                [1, "plists", table("ssbox_2_8.png", "ssbox_2_1.png")],
                [1, "pos", table([0, cc.p(0, 0)], [0, cc.p(-25, 35)])],
                [1, "angle", table([0, cc.p(45, 135)], [0, cc.p(45, 135)])],
                [1, "other", table(
                    271,
                    326,
                    0.23,
                    110,
                    220,
                    1500,
                    75,
                    10,
                    1,
                    1
                )]
            )], [1, "random", table([1, "plists", table(
                    "ssbox_2_2.png",
                    "ssbox_2_3.png",
                    "ssbox_2_4.png",
                    "ssbox_2_5.png",
                    "ssbox_2_6.png",
                    "ssbox_2_7.png"
                )], [1, "other", table(
                    6,
                    57,
                    228,
                    0.8,
                    1.5,
                    0.32,
                    314,
                    648,
                    1600,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])])],
    [0, table([1, 2, table([1, "fix", table(
                [1, "plists", table("ssbox_1_12.png")],
                [1, "pos", table([0, cc.p(-25, 35)])],
                [1, "angle", table([0, cc.p(45, 135)])],
                [1, "other", table(
                    190,
                    228,
                    0.32,
                    77,
                    154,
                    1050,
                    75,
                    10,
                    1.5,
                    1.5
                )]
            )], [1, "random", table([1, "plists", table(
                    "ssbox_1_3.png",
                    "ssbox_1_5.png",
                    "ssbox_1_9.png",
                    "ssbox_1_8.png",
                    "ssbox_1_10.png",
                    "ssbox_1_11.png",
                    "ssbox_2_2.png",
                    "ssbox_2_3.png",
                    "ssbox_2_4.png",
                    "ssbox_2_5.png",
                    "ssbox_2_6.png",
                    "ssbox_2_7.png"
                )], [1, "other", table(
                    12,
                    40,
                    160,
                    0.8,
                    1,
                    0.46,
                    220,
                    454,
                    1120,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])], [1, 1, table([1, "fix", table(
                [1, "plists", table("ssbox_2_8.png", "ssbox_2_1.png")],
                [1, "pos", table([0, cc.p(0, 0)], [0, cc.p(-25, 35)])],
                [1, "angle", table([0, cc.p(45, 135)], [0, cc.p(45, 135)])],
                [1, "other", table(
                    190,
                    228,
                    0.32,
                    77,
                    154,
                    1050,
                    75,
                    10,
                    1,
                    1
                )]
            )], [1, "random", table([1, "plists", table(
                    "ssbox_2_2.png",
                    "ssbox_2_3.png",
                    "ssbox_2_4.png",
                    "ssbox_2_5.png",
                    "ssbox_2_6.png",
                    "ssbox_2_7.png"
                )], [1, "other", table(
                    6,
                    40,
                    160,
                    0.8,
                    1.5,
                    0.46,
                    220,
                    454,
                    1120,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])])],
    [0, table([1, 2, table([1, "fix", table(
                [1, "plists", table("ssbox_1_12.png")],
                [1, "pos", table([0, cc.p(-25, 35)])],
                [1, "angle", table([0, cc.p(45, 135)])],
                [1, "other", table(
                    150,
                    179,
                    0.42,
                    60,
                    120,
                    825,
                    75,
                    10,
                    1.5,
                    1.5
                )]
            )], [1, "random", table([1, "plists", table(
                    "ssbox_1_3.png",
                    "ssbox_1_5.png",
                    "ssbox_1_9.png",
                    "ssbox_1_8.png",
                    "ssbox_1_10.png",
                    "ssbox_1_11.png",
                    "ssbox_2_2.png",
                    "ssbox_2_3.png",
                    "ssbox_2_4.png",
                    "ssbox_2_5.png",
                    "ssbox_2_6.png",
                    "ssbox_2_7.png"
                )], [1, "other", table(
                    12,
                    31,
                    125,
                    0.8,
                    1,
                    0.58,
                    173,
                    356,
                    880,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])], [1, 1, table([1, "fix", table(
                [1, "plists", table("ssbox_2_8.png", "ssbox_2_1.png")],
                [1, "pos", table([0, cc.p(0, 0)], [0, cc.p(-25, 35)])],
                [1, "angle", table([0, cc.p(45, 135)], [0, cc.p(45, 135)])],
                [1, "other", table(
                    150,
                    179,
                    0.42,
                    60,
                    120,
                    825,
                    75,
                    10,
                    1,
                    1
                )]
            )], [1, "random", table([1, "plists", table(
                    "ssbox_2_2.png",
                    "ssbox_2_3.png",
                    "ssbox_2_4.png",
                    "ssbox_2_5.png",
                    "ssbox_2_6.png",
                    "ssbox_2_7.png"
                )], [1, "other", table(
                    6,
                    31,
                    125,
                    0.8,
                    1.5,
                    0.58,
                    173,
                    356,
                    880,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])])],
    [0, table([1, 2, table([1, "fix", table(
                [1, "plists", table("ssbox_1_12.png")],
                [1, "pos", table([0, cc.p(-25, 35)])],
                [1, "angle", table([0, cc.p(45, 135)])],
                [1, "other", table(
                    125,
                    150,
                    0.5,
                    50,
                    100,
                    690,
                    75,
                    10,
                    1.5,
                    1.5
                )]
            )], [1, "random", table([1, "plists", table(
                    "ssbox_1_3.png",
                    "ssbox_1_5.png",
                    "ssbox_1_9.png",
                    "ssbox_1_8.png",
                    "ssbox_1_10.png",
                    "ssbox_1_11.png",
                    "ssbox_2_2.png",
                    "ssbox_2_3.png",
                    "ssbox_2_4.png",
                    "ssbox_2_5.png",
                    "ssbox_2_6.png",
                    "ssbox_2_7.png"
                )], [1, "other", table(
                    12,
                    26,
                    103,
                    0.8,
                    1,
                    0.69,
                    141,
                    292,
                    736,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])], [1, 1, table([1, "fix", table(
                [1, "plists", table("ssbox_2_8.png", "ssbox_2_1.png")],
                [1, "pos", table([0, cc.p(0, 0)], [0, cc.p(-25, 35)])],
                [1, "angle", table([0, cc.p(45, 135)], [0, cc.p(45, 135)])],
                [1, "other", table(
                    125,
                    150,
                    0.5,
                    50,
                    100,
                    690,
                    75,
                    10,
                    1,
                    1
                )]
            )], [1, "random", table([1, "plists", table(
                    "ssbox_2_2.png",
                    "ssbox_2_3.png",
                    "ssbox_2_4.png",
                    "ssbox_2_5.png",
                    "ssbox_2_6.png",
                    "ssbox_2_7.png"
                )], [1, "other", table(
                    6,
                    26,
                    103,
                    0.8,
                    1.5,
                    0.69,
                    141,
                    292,
                    736,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])])]
)
ParticleAnimationConfig.EggFlakeFixPosConfig = table(
    [0, table(
        [1, 3, table([1, "fix", table(
                [1, "plists", table(
                    "egg_flower3_1.png",
                    "egg_flower3_2.png",
                    "egg_flower3_3.png",
                    "egg_flower3_4.png",
                    "egg_flower3_5.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    78,
                    385,
                    0.1,
                    600,
                    785,
                    1350,
                    75,
                    10,
                    1.5,
                    1.5
                )]
            )], [1, "random", table([1, "plists", table(
                    "egg_3.png",
                    "egg_4.png",
                    "egg_7.png"
                )], [1, "other", table(
                    6,
                    57,
                    228,
                    0.6,
                    0.7,
                    0.21,
                    314,
                    648,
                    1550,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "fix", table(
                [1, "plists", table("egg_flower2_3.png")],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    78,
                    385,
                    0.1,
                    600,
                    785,
                    1350,
                    75,
                    10,
                    1.3,
                    1.3
                )]
            )], [1, "random", table([1, "plists", table(
                    "egg_flower2_1.png",
                    "egg_flower2_2.png",
                    "egg_flower2_4.png",
                    "egg_flower2_5.png"
                )], [1, "other", table(
                    7,
                    57,
                    228,
                    1.1,
                    1.3,
                    0.21,
                    314,
                    648,
                    1550,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "egg_2.png",
                    "egg_5.png",
                    "egg_6.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    55,
                    355,
                    0.1,
                    400,
                    785,
                    1350,
                    75,
                    10,
                    1,
                    1
                )]
            )], [1, "random", table([1, "plists", table(
                    "egg_1.png",
                    "egg_5.png",
                    "egg_3.png",
                    "egg_4.png",
                    "egg_7.png"
                )], [1, "other", table(
                    8,
                    57,
                    228,
                    0.8,
                    0.8,
                    0.21,
                    314,
                    648,
                    1550,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])]
    )],
    [0, table(
        [1, 3, table([1, "fix", table(
                [1, "plists", table(
                    "egg_flower3_1.png",
                    "egg_flower3_2.png",
                    "egg_flower3_3.png",
                    "egg_flower3_4.png",
                    "egg_flower3_5.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    55,
                    270,
                    0.14,
                    420,
                    550,
                    945,
                    75,
                    10,
                    1.5,
                    1.5
                )]
            )], [1, "random", table([1, "plists", table(
                    "egg_3.png",
                    "egg_4.png",
                    "egg_7.png"
                )], [1, "other", table(
                    6,
                    40,
                    160,
                    0.6,
                    0.7,
                    0.3,
                    220,
                    454,
                    1085,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "fix", table(
                [1, "plists", table("egg_flower2_3.png")],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    55,
                    270,
                    0.14,
                    420,
                    550,
                    945,
                    75,
                    10,
                    1.3,
                    1.3
                )]
            )], [1, "random", table([1, "plists", table(
                    "egg_flower2_1.png",
                    "egg_flower2_2.png",
                    "egg_flower2_4.png",
                    "egg_flower2_5.png"
                )], [1, "other", table(
                    7,
                    40,
                    160,
                    1.1,
                    1.3,
                    0.3,
                    220,
                    454,
                    1085,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "egg_2.png",
                    "egg_5.png",
                    "egg_6.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    39,
                    249,
                    0.14,
                    280,
                    550,
                    945,
                    75,
                    10,
                    1,
                    1
                )]
            )], [1, "random", table([1, "plists", table(
                    "egg_1.png",
                    "egg_5.png",
                    "egg_3.png",
                    "egg_4.png",
                    "egg_7.png"
                )], [1, "other", table(
                    8,
                    40,
                    160,
                    0.8,
                    0.8,
                    0.3,
                    220,
                    454,
                    1085,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])]
    )],
    [0, table(
        [1, 3, table([1, "fix", table(
                [1, "plists", table(
                    "egg_flower3_1.png",
                    "egg_flower3_2.png",
                    "egg_flower3_3.png",
                    "egg_flower3_4.png",
                    "egg_flower3_5.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    43,
                    212,
                    0.18,
                    330,
                    432,
                    715,
                    75,
                    10,
                    1.5,
                    1.5
                )]
            )], [1, "random", table([1, "plists", table(
                    "egg_3.png",
                    "egg_4.png",
                    "egg_7.png"
                )], [1, "other", table(
                    6,
                    31,
                    125,
                    0.6,
                    0.7,
                    0.38,
                    173,
                    356,
                    853,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "fix", table(
                [1, "plists", table("egg_flower2_3.png")],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    43,
                    212,
                    0.18,
                    330,
                    432,
                    715,
                    75,
                    10,
                    1.3,
                    1.3
                )]
            )], [1, "random", table([1, "plists", table(
                    "egg_flower2_1.png",
                    "egg_flower2_2.png",
                    "egg_flower2_4.png",
                    "egg_flower2_5.png"
                )], [1, "other", table(
                    7,
                    31,
                    125,
                    1.1,
                    1.3,
                    0.38,
                    173,
                    301,
                    853,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "egg_2.png",
                    "egg_5.png",
                    "egg_6.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    30,
                    195,
                    0.18,
                    220,
                    432,
                    715,
                    75,
                    10,
                    1,
                    1
                )]
            )], [1, "random", table([1, "plists", table(
                    "egg_1.png",
                    "egg_5.png",
                    "egg_3.png",
                    "egg_4.png",
                    "egg_7.png"
                )], [1, "other", table(
                    8,
                    31,
                    125,
                    0.8,
                    0.8,
                    0.38,
                    173,
                    356,
                    853,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])]
    )],
    [0, table(
        [1, 3, table([1, "fix", table(
                [1, "plists", table(
                    "egg_flower3_1.png",
                    "egg_flower3_2.png",
                    "egg_flower3_3.png",
                    "egg_flower3_4.png",
                    "egg_flower3_5.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    36,
                    177,
                    0.22,
                    276,
                    361,
                    621,
                    75,
                    10,
                    1.5,
                    1.5
                )]
            )], [1, "random", table([1, "plists", table(
                    "egg_3.png",
                    "egg_4.png",
                    "egg_7.png"
                )], [1, "other", table(
                    6,
                    26,
                    105,
                    0.6,
                    0.7,
                    0.46,
                    144,
                    298,
                    713,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "fix", table(
                [1, "plists", table("egg_flower2_3.png")],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    36,
                    177,
                    0.22,
                    276,
                    361,
                    621,
                    75,
                    10,
                    1.3,
                    1.3
                )]
            )], [1, "random", table([1, "plists", table(
                    "egg_flower2_1.png",
                    "egg_flower2_2.png",
                    "egg_flower2_4.png",
                    "egg_flower2_5.png"
                )], [1, "other", table(
                    7,
                    26,
                    105,
                    1.1,
                    1.3,
                    0.46,
                    144,
                    298,
                    713,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "egg_2.png",
                    "egg_5.png",
                    "egg_6.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    25,
                    163,
                    0.22,
                    184,
                    361,
                    621,
                    75,
                    10,
                    1,
                    1
                )]
            )], [1, "random", table([1, "plists", table(
                    "egg_1.png",
                    "egg_5.png",
                    "egg_3.png",
                    "egg_4.png",
                    "egg_7.png"
                )], [1, "other", table(
                    8,
                    26,
                    105,
                    0.8,
                    0.8,
                    0.46,
                    144,
                    298,
                    713,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])]
    )]
)
ParticleAnimationConfig.CoinFlakeFixPosConfig = table(
    [0, table([1, 1, table([1, "fix", table(
                [1, "plists", table("coin_bigshell1.png", "coin_bigshell2.png")],
                [1, "pos", table([0, cc.p(-25, 35)], [0, cc.p(35, 35)])],
                [1, "angle", table([0, cc.p(95, 150)], [0, cc.p(30, 85)])],
                [1, "other", table(
                    45,
                    285,
                    0.21,
                    314,
                    648,
                    1350,
                    75,
                    10,
                    1,
                    1
                )]
            )], [1, "random", table([1, "plists", table(
                    "coin_shell_3.png",
                    "coin_shell_4.png",
                    "coin_shell_5.png",
                    "coin_water_3.png",
                    "coin_water_4.png",
                    "coin_water_5.png",
                    "coin_water_5.png",
                    "coin_water_5.png"
                )], [1, "other", table(
                    10,
                    57,
                    228,
                    0.8,
                    1.5,
                    0.21,
                    314,
                    648,
                    1550,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])])],
    [0, table([1, 1, table([1, "fix", table(
                [1, "plists", table("coin_bigshell1.png", "coin_bigshell2.png")],
                [1, "pos", table([0, cc.p(-25, 35)], [0, cc.p(35, 35)])],
                [1, "angle", table([0, cc.p(95, 150)], [0, cc.p(30, 85)])],
                [1, "other", table(
                    32,
                    200,
                    0.3,
                    220,
                    454,
                    945,
                    75,
                    10,
                    1,
                    1
                )]
            )], [1, "random", table([1, "plists", table(
                    "coin_shell_3.png",
                    "coin_shell_4.png",
                    "coin_shell_5.png",
                    "coin_water_3.png",
                    "coin_water_4.png",
                    "coin_water_5.png",
                    "coin_water_5.png",
                    "coin_water_5.png"
                )], [1, "other", table(
                    10,
                    40,
                    160,
                    0.8,
                    1.5,
                    0.3,
                    220,
                    454,
                    1085,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])])],
    [0, table([1, 1, table([1, "fix", table(
                [1, "plists", table("coin_bigshell1.png", "coin_bigshell2.png")],
                [1, "pos", table([0, cc.p(-25, 35)], [0, cc.p(35, 35)])],
                [1, "angle", table([0, cc.p(95, 150)], [0, cc.p(30, 85)])],
                [1, "other", table(
                    25,
                    157,
                    0.38,
                    173,
                    356,
                    743,
                    75,
                    10,
                    1,
                    1
                )]
            )], [1, "random", table([1, "plists", table(
                    "coin_shell_3.png",
                    "coin_shell_4.png",
                    "coin_shell_5.png",
                    "coin_water_3.png",
                    "coin_water_4.png",
                    "coin_water_5.png",
                    "coin_water_5.png",
                    "coin_water_5.png"
                )], [1, "other", table(
                    10,
                    31,
                    125,
                    0.8,
                    1.5,
                    0.38,
                    173,
                    356,
                    853,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])])],
    [0, table([1, 1, table([1, "fix", table(
                [1, "plists", table("coin_bigshell1.png", "coin_bigshell2.png")],
                [1, "pos", table([0, cc.p(-25, 35)], [0, cc.p(35, 35)])],
                [1, "angle", table([0, cc.p(95, 150)], [0, cc.p(30, 85)])],
                [1, "other", table(
                    21,
                    131,
                    0.46,
                    144,
                    298,
                    621,
                    75,
                    10,
                    1,
                    1
                )]
            )], [1, "random", table([1, "plists", table(
                    "coin_shell_3.png",
                    "coin_shell_4.png",
                    "coin_shell_5.png",
                    "coin_water_3.png",
                    "coin_water_4.png",
                    "coin_water_5.png",
                    "coin_water_5.png",
                    "coin_water_5.png"
                )], [1, "other", table(
                    10,
                    26,
                    104,
                    0.8,
                    1.5,
                    0.46,
                    144,
                    298,
                    713,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])])]
)
ParticleAnimationConfig.BiscuitFlakeFixPosConfig = table(
    [0, table(
        [1, 4, table([1, "random", table([1, "plists", table(
                    "biscuit_small_02.png",
                    "biscuit_small_03.png",
                    "biscuit_small_04.png",
                    "biscuit_big_05.png",
                    "biscuit_small_06.png"
                )], [1, "other", table(
                    8,
                    57,
                    228,
                    0.4,
                    1.1,
                    0.21,
                    314,
                    648,
                    1550,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 3, table([1, "random", table([1, "plists", table(
                    "biscuit_small_02.png",
                    "biscuit_small_03.png",
                    "biscuit_small_04.png",
                    "biscuit_big_05.png",
                    "biscuit_small_06.png"
                )], [1, "other", table(
                    8,
                    57,
                    228,
                    0.4,
                    1.1,
                    0.21,
                    314,
                    648,
                    1550,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "random", table([1, "plists", table(
                    "biscuit_small_02.png",
                    "biscuit_small_03.png",
                    "biscuit_small_04.png",
                    "biscuit_big_05.png",
                    "biscuit_small_06.png"
                )], [1, "other", table(
                    8,
                    57,
                    228,
                    0.4,
                    1.1,
                    0.21,
                    314,
                    648,
                    1550,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "biscuit_big_02.png",
                    "biscuit_big_04.png",
                    "biscuit_big_07.png",
                    "biscuit_big_08.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    78,
                    385,
                    0.1,
                    600,
                    785,
                    1550,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "biscuit_small_02.png",
                    "biscuit_small_03.png",
                    "biscuit_small_04.png",
                    "biscuit_small_06.png",
                    "biscuit_big_01.png",
                    "biscuit_big_03.png",
                    "biscuit_big_05.png",
                    "biscuit_big_06.png"
                )], [1, "other", table(
                    12,
                    57,
                    228,
                    0.8,
                    1.5,
                    0.21,
                    314,
                    648,
                    1550,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])]
    )],
    [0, table(
        [1, 4, table([1, "random", table([1, "plists", table(
                    "biscuit_small_02.png",
                    "biscuit_small_03.png",
                    "biscuit_small_04.png",
                    "biscuit_big_05.png",
                    "biscuit_small_06.png"
                )], [1, "other", table(
                    8,
                    40,
                    160,
                    0.4,
                    1.1,
                    0.3,
                    220,
                    454,
                    1085,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 3, table([1, "random", table([1, "plists", table(
                    "biscuit_small_02.png",
                    "biscuit_small_03.png",
                    "biscuit_small_04.png",
                    "biscuit_big_05.png",
                    "biscuit_small_06.png"
                )], [1, "other", table(
                    8,
                    40,
                    160,
                    0.4,
                    1.1,
                    0.3,
                    220,
                    454,
                    1085,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "random", table([1, "plists", table(
                    "biscuit_small_02.png",
                    "biscuit_small_03.png",
                    "biscuit_small_04.png",
                    "biscuit_big_05.png",
                    "biscuit_small_06.png"
                )], [1, "other", table(
                    8,
                    40,
                    160,
                    0.4,
                    1.1,
                    0.3,
                    220,
                    454,
                    1085,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "biscuit_big_02.png",
                    "biscuit_big_04.png",
                    "biscuit_big_07.png",
                    "biscuit_big_08.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    55,
                    340,
                    0.14,
                    420,
                    550,
                    1085,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "biscuit_small_02.png",
                    "biscuit_small_03.png",
                    "biscuit_small_04.png",
                    "biscuit_small_06.png",
                    "biscuit_big_01.png",
                    "biscuit_big_03.png",
                    "biscuit_big_05.png",
                    "biscuit_big_06.png"
                )], [1, "other", table(
                    12,
                    40,
                    160,
                    0.8,
                    1.5,
                    0.3,
                    220,
                    454,
                    1085,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])]
    )],
    [0, table(
        [1, 4, table([1, "random", table([1, "plists", table(
                    "biscuit_small_02.png",
                    "biscuit_small_03.png",
                    "biscuit_small_04.png",
                    "biscuit_big_05.png",
                    "biscuit_small_06.png"
                )], [1, "other", table(
                    8,
                    31,
                    125,
                    0.4,
                    1.1,
                    0.38,
                    173,
                    356,
                    853,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 3, table([1, "random", table([1, "plists", table(
                    "biscuit_small_02.png",
                    "biscuit_small_03.png",
                    "biscuit_small_04.png",
                    "biscuit_big_05.png",
                    "biscuit_small_06.png"
                )], [1, "other", table(
                    8,
                    31,
                    125,
                    0.4,
                    1.1,
                    0.38,
                    173,
                    356,
                    853,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "random", table([1, "plists", table(
                    "biscuit_small_02.png",
                    "biscuit_small_03.png",
                    "biscuit_small_04.png",
                    "biscuit_big_05.png",
                    "biscuit_small_06.png"
                )], [1, "other", table(
                    8,
                    31,
                    125,
                    0.4,
                    1.1,
                    0.38,
                    173,
                    356,
                    853,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "biscuit_big_02.png",
                    "biscuit_big_04.png",
                    "biscuit_big_07.png",
                    "biscuit_big_08.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    43,
                    267,
                    0.18,
                    330,
                    432,
                    853,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "biscuit_small_02.png",
                    "biscuit_small_03.png",
                    "biscuit_small_04.png",
                    "biscuit_small_06.png",
                    "biscuit_big_01.png",
                    "biscuit_big_03.png",
                    "biscuit_big_05.png",
                    "biscuit_big_06.png"
                )], [1, "other", table(
                    12,
                    31,
                    125,
                    0.8,
                    1.5,
                    0.38,
                    173,
                    356,
                    853,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])]
    )],
    [0, table(
        [1, 4, table([1, "random", table([1, "plists", table(
                    "biscuit_small_02.png",
                    "biscuit_small_03.png",
                    "biscuit_small_04.png",
                    "biscuit_big_05.png",
                    "biscuit_small_06.png"
                )], [1, "other", table(
                    8,
                    26,
                    105,
                    0.4,
                    1.1,
                    0.46,
                    144,
                    298,
                    713,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 3, table([1, "random", table([1, "plists", table(
                    "biscuit_small_02.png",
                    "biscuit_small_03.png",
                    "biscuit_small_04.png",
                    "biscuit_big_05.png",
                    "biscuit_small_06.png"
                )], [1, "other", table(
                    8,
                    26,
                    105,
                    0.4,
                    1.1,
                    0.46,
                    144,
                    298,
                    713,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "random", table([1, "plists", table(
                    "biscuit_small_02.png",
                    "biscuit_small_03.png",
                    "biscuit_small_04.png",
                    "biscuit_big_05.png",
                    "biscuit_small_06.png"
                )], [1, "other", table(
                    8,
                    26,
                    105,
                    0.4,
                    1.1,
                    0.46,
                    144,
                    298,
                    713,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "biscuit_big_02.png",
                    "biscuit_big_04.png",
                    "biscuit_big_07.png",
                    "biscuit_big_08.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    36,
                    223,
                    0.22,
                    276,
                    361,
                    713,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "biscuit_small_02.png",
                    "biscuit_small_03.png",
                    "biscuit_small_04.png",
                    "biscuit_small_06.png",
                    "biscuit_big_01.png",
                    "biscuit_big_03.png",
                    "biscuit_big_05.png",
                    "biscuit_big_06.png"
                )], [1, "other", table(
                    12,
                    26,
                    105,
                    0.8,
                    1.5,
                    0.46,
                    144,
                    298,
                    713,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])]
    )]
)
ParticleAnimationConfig.IceAnimalFlakeFixPosConfig = table(
    [0, table(
        [1, 3, table([1, "fix", table(
                [1, "plists", table(
                    "ice_lv1_1.png",
                    "ice_lv1_2.png",
                    "ice_lv1_5.png",
                    "ice_lv1_6.png",
                    "ice_lv1_8.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(5, 30)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(-15, -25)],
                    [0, cc.p(35, -35)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 110)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(150, 270)],
                    [0, cc.p(200, 270)]
                )],
                [1, "other", table(
                    78,
                    285,
                    0.1,
                    300,
                    585,
                    1250,
                    80,
                    12
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_lv1_5.png",
                    "ice_lv1_6.png",
                    "ice_lv1_8.png"
                )], [1, "other", table(
                    5,
                    157,
                    328,
                    0.1,
                    0.7,
                    0.21,
                    314,
                    548,
                    1250,
                    80,
                    12,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "fix", table(
                [1, "plists", table(
                    "ice_lv1_1.png",
                    "ice_lv1_2.png",
                    "ice_lv1_5.png",
                    "ice_lv1_6.png",
                    "ice_lv1_8.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(5, 30)],
                    [0, cc.p(35, 5)],
                    [0, cc.p(-35, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(-15, -25)],
                    [0, cc.p(35, -35)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 110)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(40, 90)],
                    [0, cc.p(80, 150)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(150, 270)],
                    [0, cc.p(200, 270)]
                )],
                [1, "other", table(
                    78,
                    285,
                    0.1,
                    300,
                    585,
                    1250,
                    80,
                    12
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_lv1_5.png",
                    "ice_lv1_6.png",
                    "ice_lv1_8.png"
                )], [1, "other", table(
                    5,
                    57,
                    228,
                    0.1,
                    0.7,
                    0.21,
                    314,
                    548,
                    1250,
                    80,
                    12,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "ice_lv1_1.png",
                    "ice_lv1_2.png",
                    "ice_lv1_5.png",
                    "ice_lv1_6.png",
                    "ice_lv1_8.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(5, 30)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(-15, -25)],
                    [0, cc.p(35, -35)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 110)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(150, 270)],
                    [0, cc.p(200, 270)]
                )],
                [1, "other", table(
                    78,
                    285,
                    0.1,
                    300,
                    585,
                    1250,
                    85,
                    14
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_lv1_5.png",
                    "ice_lv1_6.png",
                    "ice_lv1_8.png"
                )], [1, "other", table(
                    6,
                    57,
                    228,
                    0.1,
                    0.7,
                    0.21,
                    314,
                    548,
                    1250,
                    85,
                    14,
                    [0, table([1, "square", 40])]
                )])])]
    )],
    [0, table(
        [1, 3, table([1, "fix", table(
                [1, "plists", table(
                    "ice_lv1_1.png",
                    "ice_lv1_2.png",
                    "ice_lv1_5.png",
                    "ice_lv1_6.png",
                    "ice_lv1_8.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(5, 30)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(-15, -25)],
                    [0, cc.p(35, -35)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 110)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(150, 270)],
                    [0, cc.p(200, 270)]
                )],
                [1, "other", table(
                    55,
                    200,
                    0.14,
                    210,
                    410,
                    875,
                    80,
                    12
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_lv1_5.png",
                    "ice_lv1_6.png",
                    "ice_lv1_8.png"
                )], [1, "other", table(
                    5,
                    40,
                    160,
                    0.1,
                    0.7,
                    0.21,
                    220,
                    384,
                    875,
                    80,
                    12,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "fix", table(
                [1, "plists", table(
                    "ice_lv1_1.png",
                    "ice_lv1_2.png",
                    "ice_lv1_5.png",
                    "ice_lv1_6.png",
                    "ice_lv1_8.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(5, 30)],
                    [0, cc.p(35, 5)],
                    [0, cc.p(-35, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(-15, -25)],
                    [0, cc.p(35, -35)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 110)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(40, 90)],
                    [0, cc.p(80, 150)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(150, 270)],
                    [0, cc.p(200, 270)]
                )],
                [1, "other", table(
                    55,
                    200,
                    0.14,
                    210,
                    410,
                    875,
                    80,
                    12
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_lv1_5.png",
                    "ice_lv1_6.png",
                    "ice_lv1_8.png"
                )], [1, "other", table(
                    5,
                    40,
                    160,
                    0.1,
                    0.7,
                    0.21,
                    220,
                    384,
                    875,
                    80,
                    12,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "ice_lv1_1.png",
                    "ice_lv1_2.png",
                    "ice_lv1_5.png",
                    "ice_lv1_6.png",
                    "ice_lv1_8.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(5, 30)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(-15, -25)],
                    [0, cc.p(35, -35)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 110)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(150, 270)],
                    [0, cc.p(200, 270)]
                )],
                [1, "other", table(
                    55,
                    200,
                    0.14,
                    210,
                    410,
                    875,
                    85,
                    14
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_lv1_5.png",
                    "ice_lv1_6.png",
                    "ice_lv1_8.png"
                )], [1, "other", table(
                    6,
                    40,
                    160,
                    0.1,
                    0.7,
                    0.21,
                    220,
                    384,
                    875,
                    85,
                    14,
                    [0, table([1, "square", 40])]
                )])])]
    )],
    [0, table(
        [1, 3, table([1, "fix", table(
                [1, "plists", table(
                    "ice_lv1_1.png",
                    "ice_lv1_2.png",
                    "ice_lv1_5.png",
                    "ice_lv1_6.png",
                    "ice_lv1_8.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(5, 30)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(-15, -25)],
                    [0, cc.p(35, -35)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 110)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(150, 270)],
                    [0, cc.p(200, 270)]
                )],
                [1, "other", table(
                    43,
                    157,
                    0.18,
                    165,
                    322,
                    688,
                    80,
                    12
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_lv1_5.png",
                    "ice_lv1_6.png",
                    "ice_lv1_8.png"
                )], [1, "other", table(
                    5,
                    31,
                    125,
                    0.1,
                    0.7,
                    0.38,
                    173,
                    301,
                    688,
                    80,
                    12,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "fix", table(
                [1, "plists", table(
                    "ice_lv1_1.png",
                    "ice_lv1_2.png",
                    "ice_lv1_5.png",
                    "ice_lv1_6.png",
                    "ice_lv1_8.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(5, 30)],
                    [0, cc.p(35, 5)],
                    [0, cc.p(-35, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(-15, -25)],
                    [0, cc.p(35, -35)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 110)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(40, 90)],
                    [0, cc.p(80, 150)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(150, 270)],
                    [0, cc.p(200, 270)]
                )],
                [1, "other", table(
                    43,
                    157,
                    0.18,
                    165,
                    322,
                    688,
                    80,
                    12
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_lv1_5.png",
                    "ice_lv1_6.png",
                    "ice_lv1_8.png"
                )], [1, "other", table(
                    5,
                    31,
                    125,
                    0.1,
                    0.7,
                    0.38,
                    173,
                    301,
                    688,
                    80,
                    12,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "ice_lv1_1.png",
                    "ice_lv1_2.png",
                    "ice_lv1_5.png",
                    "ice_lv1_6.png",
                    "ice_lv1_8.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(5, 30)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(-15, -25)],
                    [0, cc.p(35, -35)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 110)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(150, 270)],
                    [0, cc.p(200, 270)]
                )],
                [1, "other", table(
                    43,
                    157,
                    0.18,
                    165,
                    322,
                    688,
                    85,
                    14
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_lv1_5.png",
                    "ice_lv1_6.png",
                    "ice_lv1_8.png"
                )], [1, "other", table(
                    6,
                    31,
                    125,
                    0.1,
                    0.7,
                    0.38,
                    173,
                    301,
                    688,
                    85,
                    14,
                    [0, table([1, "square", 40])]
                )])])]
    )],
    [0, table(
        [1, 3, table([1, "fix", table(
                [1, "plists", table(
                    "ice_lv1_1.png",
                    "ice_lv1_2.png",
                    "ice_lv1_5.png",
                    "ice_lv1_6.png",
                    "ice_lv1_8.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(5, 30)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(-15, -25)],
                    [0, cc.p(35, -35)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 110)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(150, 270)],
                    [0, cc.p(200, 270)]
                )],
                [1, "other", table(
                    36,
                    131,
                    0.22,
                    138,
                    269,
                    575,
                    80,
                    12
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_lv1_5.png",
                    "ice_lv1_6.png",
                    "ice_lv1_8.png"
                )], [1, "other", table(
                    5,
                    26,
                    105,
                    0.1,
                    0.7,
                    0.46,
                    144,
                    252,
                    575,
                    80,
                    12,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "fix", table(
                [1, "plists", table(
                    "ice_lv1_1.png",
                    "ice_lv1_2.png",
                    "ice_lv1_5.png",
                    "ice_lv1_6.png",
                    "ice_lv1_8.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(5, 30)],
                    [0, cc.p(35, 5)],
                    [0, cc.p(-35, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(-15, -25)],
                    [0, cc.p(35, -35)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 110)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(40, 90)],
                    [0, cc.p(80, 150)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(150, 270)],
                    [0, cc.p(200, 270)]
                )],
                [1, "other", table(
                    36,
                    131,
                    0.22,
                    138,
                    269,
                    575,
                    80,
                    12
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_lv1_5.png",
                    "ice_lv1_6.png",
                    "ice_lv1_8.png"
                )], [1, "other", table(
                    5,
                    26,
                    105,
                    0.1,
                    0.7,
                    0.46,
                    144,
                    252,
                    575,
                    80,
                    12,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "ice_lv1_1.png",
                    "ice_lv1_2.png",
                    "ice_lv1_5.png",
                    "ice_lv1_6.png",
                    "ice_lv1_8.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(5, 30)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(-15, -25)],
                    [0, cc.p(35, -35)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 110)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(150, 270)],
                    [0, cc.p(200, 270)]
                )],
                [1, "other", table(
                    36,
                    131,
                    0.22,
                    138,
                    269,
                    575,
                    85,
                    14
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_lv1_5.png",
                    "ice_lv1_6.png",
                    "ice_lv1_8.png"
                )], [1, "other", table(
                    6,
                    26,
                    105,
                    0.1,
                    0.7,
                    0.46,
                    144,
                    252,
                    575,
                    85,
                    14,
                    [0, table([1, "square", 40])]
                )])])]
    )]
)
ParticleAnimationConfig.DiamondFlakeFixPosConfig = table(
    [0, table(
        [1, 3, table([1, "random", table([1, "plists", table(
                    "diamond_samll_2.png",
                    "diamond_samll_3.png",
                    "diamond_samll_5.png",
                    "diamond_samll_6.png"
                )], [1, "other", table(
                    8,
                    57,
                    240,
                    0.2,
                    1.0,
                    0.21,
                    300,
                    748,
                    1650,
                    78,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "random", table([1, "plists", table(
                    "diamond_big_1.png",
                    "diamond_big_2.png",
                    "diamond_samll_2.png",
                    "diamond_samll_3.png",
                    "diamond_samll_5.png",
                    "diamond_samll_6.png"
                )], [1, "other", table(
                    10,
                    57,
                    228,
                    0.2,
                    1.0,
                    0.21,
                    300,
                    748,
                    1550,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table("diamond_big_1.png", "diamond_big_2.png")],
                [1, "pos", table([0, cc.p(-35, 0)], [0, cc.p(0, 25)])],
                [1, "angle", table([0, cc.p(90, 140)], [0, cc.p(20, 90)])],
                [1, "other", table(
                    55,
                    210,
                    0.14,
                    210,
                    420,
                    1155,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "diamond_big_1.png",
                    "diamond_big_2.png",
                    "diamond_samll_1.png",
                    "diamond_big_5.png",
                    "diamond_samll_2.png",
                    "diamond_samll_3.png",
                    "diamond_samll_4.png",
                    "diamond_samll_5.png",
                    "diamond_samll_6.png"
                )], [1, "other", table(
                    9,
                    57,
                    228,
                    0.1,
                    1.0,
                    0.21,
                    300,
                    600,
                    1550,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])]
    )],
    [0, table(
        [1, 3, table([1, "random", table([1, "plists", table(
                    "diamond_samll_2.png",
                    "diamond_samll_3.png",
                    "diamond_samll_5.png",
                    "diamond_samll_6.png"
                )], [1, "other", table(
                    8,
                    40,
                    168,
                    0.2,
                    1.0,
                    0.3,
                    210,
                    524,
                    1155,
                    78,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "random", table([1, "plists", table(
                    "diamond_big_1.png",
                    "diamond_big_2.png",
                    "diamond_samll_2.png",
                    "diamond_samll_3.png",
                    "diamond_samll_5.png",
                    "diamond_samll_6.png"
                )], [1, "other", table(
                    10,
                    40,
                    160,
                    0.2,
                    1.0,
                    0.3,
                    210,
                    524,
                    1085,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table("diamond_big_1.png", "diamond_big_2.png")],
                [1, "pos", table([0, cc.p(-35, 0)], [0, cc.p(0, 25)])],
                [1, "angle", table([0, cc.p(90, 140)], [0, cc.p(20, 90)])],
                [1, "other", table(
                    55,
                    210,
                    0.14,
                    210,
                    420,
                    1155,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "diamond_big_1.png",
                    "diamond_big_2.png",
                    "diamond_samll_1.png",
                    "diamond_big_5.png",
                    "diamond_samll_2.png",
                    "diamond_samll_3.png",
                    "diamond_samll_4.png",
                    "diamond_samll_5.png",
                    "diamond_samll_6.png"
                )], [1, "other", table(
                    9,
                    40,
                    160,
                    0.1,
                    1.0,
                    0.3,
                    210,
                    524,
                    1155,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])]
    )],
    [0, table(
        [1, 3, table([1, "random", table([1, "plists", table(
                    "diamond_samll_2.png",
                    "diamond_samll_3.png",
                    "diamond_samll_5.png",
                    "diamond_samll_6.png"
                )], [1, "other", table(
                    8,
                    31,
                    132,
                    0.2,
                    1.0,
                    0.38,
                    165,
                    411,
                    908,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "random", table([1, "plists", table(
                    "diamond_big_1.png",
                    "diamond_big_2.png",
                    "diamond_samll_2.png",
                    "diamond_samll_3.png",
                    "diamond_samll_5.png",
                    "diamond_samll_6.png"
                )], [1, "other", table(
                    10,
                    31,
                    125,
                    0.2,
                    1.0,
                    0.38,
                    165,
                    411,
                    853,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table("diamond_big_1.png", "diamond_big_2.png")],
                [1, "pos", table([0, cc.p(-35, 0)], [0, cc.p(0, 25)])],
                [1, "angle", table([0, cc.p(90, 140)], [0, cc.p(20, 90)])],
                [1, "other", table(
                    43,
                    165,
                    0.18,
                    165,
                    330,
                    908,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "diamond_big_1.png",
                    "diamond_big_2.png",
                    "diamond_samll_1.png",
                    "diamond_big_5.png",
                    "diamond_samll_2.png",
                    "diamond_samll_3.png",
                    "diamond_samll_4.png",
                    "diamond_samll_5.png",
                    "diamond_samll_6.png"
                )], [1, "other", table(
                    9,
                    31,
                    125,
                    0.1,
                    1.0,
                    0.38,
                    165,
                    330,
                    908,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])]
    )],
    [0, table(
        [1, 3, table([1, "random", table([1, "plists", table(
                    "diamond_samll_2.png",
                    "diamond_samll_3.png",
                    "diamond_samll_5.png",
                    "diamond_samll_6.png"
                )], [1, "other", table(
                    8,
                    26,
                    110,
                    0.2,
                    1.0,
                    0.46,
                    138,
                    344,
                    759,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "random", table([1, "plists", table(
                    "diamond_big_1.png",
                    "diamond_big_2.png",
                    "diamond_samll_2.png",
                    "diamond_samll_3.png",
                    "diamond_samll_5.png",
                    "diamond_samll_6.png"
                )], [1, "other", table(
                    10,
                    26,
                    105,
                    0.2,
                    1.0,
                    0.46,
                    138,
                    276,
                    759,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table("diamond_big_1.png", "diamond_big_2.png")],
                [1, "pos", table([0, cc.p(-35, 0)], [0, cc.p(0, 25)])],
                [1, "angle", table([0, cc.p(90, 140)], [0, cc.p(20, 90)])],
                [1, "other", table(
                    36,
                    138,
                    0.22,
                    138,
                    276,
                    759,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "diamond_big_1.png",
                    "diamond_big_2.png",
                    "diamond_samll_1.png",
                    "diamond_big_5.png",
                    "diamond_samll_2.png",
                    "diamond_samll_3.png",
                    "diamond_samll_4.png",
                    "diamond_samll_5.png",
                    "diamond_samll_6.png"
                )], [1, "other", table(
                    9,
                    26,
                    105,
                    0.1,
                    1.0,
                    0.46,
                    138,
                    276,
                    759,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])]
    )]
)
ParticleAnimationConfig.CandyCaneFlakeFixPosConfig = table(
    [0, table([1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "candyCane/76qipan_1.png",
                    "candyCane/76qipan_2.png",
                    "candyCane/76qipan_3.png"
                )],
                [1, "pos", table(
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    78,
                    485,
                    0.1,
                    600,
                    785,
                    1550,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "candyCane/76qipan_4.png",
                    "candyCane/76qipan_5.png",
                    "candyCane/76qipan_6.png",
                    "candyCane/76qipan_7.png",
                    "candyCane/76qipan_8.png",
                    "candyCane/76qipan_9.png"
                )], [1, "other", table(
                    7,
                    57,
                    228,
                    0.5,
                    1.3,
                    0.21,
                    314,
                    648,
                    1550,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])])],
    [0, table([1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "candyCane/76qipan_1.png",
                    "candyCane/76qipan_2.png",
                    "candyCane/76qipan_3.png"
                )],
                [1, "pos", table(
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    55,
                    340,
                    0.16,
                    420,
                    550,
                    1085,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "candyCane/76qipan_4.png",
                    "candyCane/76qipan_5.png",
                    "candyCane/76qipan_6.png",
                    "candyCane/76qipan_7.png",
                    "candyCane/76qipan_8.png",
                    "candyCane/76qipan_9.png"
                )], [1, "other", table(
                    7,
                    57,
                    228,
                    0.5,
                    1.3,
                    0.41,
                    220,
                    454,
                    1085,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])])],
    [0, table([1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "candyCane/76qipan_1.png",
                    "candyCane/76qipan_2.png",
                    "candyCane/76qipan_3.png"
                )],
                [1, "pos", table(
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    43,
                    266,
                    0.26,
                    330,
                    431,
                    853,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "candyCane/76qipan_4.png",
                    "candyCane/76qipan_5.png",
                    "candyCane/76qipan_6.png",
                    "candyCane/76qipan_7.png",
                    "candyCane/76qipan_8.png",
                    "candyCane/76qipan_9.png"
                )], [1, "other", table(
                    7,
                    57,
                    228,
                    0.5,
                    1.3,
                    0.41,
                    314,
                    648,
                    1550,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])])],
    [0, table([1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "candyCane/76qipan_1.png",
                    "candyCane/76qipan_2.png",
                    "candyCane/76qipan_3.png"
                )],
                [1, "pos", table(
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    36,
                    223,
                    0.36,
                    276,
                    361,
                    713,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "candyCane/76qipan_4.png",
                    "candyCane/76qipan_5.png",
                    "candyCane/76qipan_6.png",
                    "candyCane/76qipan_7.png",
                    "candyCane/76qipan_8.png",
                    "candyCane/76qipan_9.png"
                )], [1, "other", table(
                    7,
                    57,
                    228,
                    0.5,
                    1.3,
                    0.61,
                    144,
                    298,
                    713,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])])]
)
ParticleAnimationConfig.MangosteenFlakeFixPosConfig = table(
    [0, table(
        [1, 4, table([1, "fix", table(
                [1, "plists", table("ke_3.png", "yezi_1.png")],
                [1, "pos", table([0, cc.p(0, 0)], [0, cc.p(0, 0)])],
                [1, "angle", table([0, cc.p(60, 120)], [0, cc.p(30, 150)])],
                [1, "other", table(
                    78,
                    285,
                    0.1,
                    300,
                    585,
                    1250,
                    80,
                    12
                )]
            )], [1, "random", table([1, "plists", table(
                    "ke_1.png",
                    "ke_4.png",
                    "ke_7.png",
                    "ke_8.png",
                    "ke_9.png"
                )], [1, "other", table(
                    7,
                    157,
                    328,
                    0.1,
                    0.9,
                    0.21,
                    314,
                    548,
                    1250,
                    80,
                    12,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 3, table([1, "fix", table(
                [1, "plists", table(
                    "ke_2.png",
                    "yezi_5.png",
                    "yezi_2.png",
                    "ke_10.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(25, -35)]
                )],
                [1, "angle", table(
                    [0, cc.p(120, 220)],
                    [0, cc.p(30, 150)],
                    [0, cc.p(30, 150)],
                    [0, cc.p(-60, 60)]
                )],
                [1, "other", table(
                    78,
                    285,
                    0.1,
                    300,
                    585,
                    1250,
                    80,
                    12
                )]
            )], [1, "random", table([1, "plists", table(
                    "ke_1.png",
                    "ke_4.png",
                    "ke_7.png",
                    "ke_8.png",
                    "ke_9.png"
                )], [1, "other", table(
                    7,
                    157,
                    328,
                    0.1,
                    0.9,
                    0.21,
                    314,
                    548,
                    1250,
                    80,
                    12,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "fix", table(
                [1, "plists", table(
                    "ke_3.png",
                    "ke_6.png",
                    "ke_5.png",
                    "yezi_4.png",
                    "yezi_3.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(25, 30)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(120, 220)],
                    [0, cc.p(30, 150)],
                    [0, cc.p(-60, 60)],
                    [0, cc.p(30, 150)],
                    [0, cc.p(30, 150)]
                )],
                [1, "other", table(
                    78,
                    285,
                    0.1,
                    300,
                    585,
                    1250,
                    80,
                    12
                )]
            )], [1, "random", table([1, "plists", table(
                    "ke_1.png",
                    "ke_4.png",
                    "ke_7.png",
                    "ke_8.png",
                    "ke_9.png"
                )], [1, "other", table(
                    7,
                    157,
                    328,
                    0.1,
                    0.9,
                    0.21,
                    314,
                    548,
                    1250,
                    80,
                    12,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "ke_6.png",
                    "ke_5.png",
                    "ke_2.png",
                    "ke_10.png"
                )],
                [1, "pos", table(
                    [0, cc.p(0, 0)],
                    [0, cc.p(15, 25)],
                    [0, cc.p(-15, -25)],
                    [0, cc.p(-15, -25)]
                )],
                [1, "angle", table(
                    [0, cc.p(30, 150)],
                    [0, cc.p(-60, 60)],
                    [0, cc.p(120, 220)],
                    [0, cc.p(-60, 60)]
                )],
                [1, "other", table(
                    78,
                    285,
                    0.1,
                    300,
                    585,
                    1250,
                    80,
                    12
                )]
            )], [1, "random", table([1, "plists", table(
                    "ke_1.png",
                    "ke_4.png",
                    "ke_7.png",
                    "ke_8.png",
                    "ke_9.png"
                )], [1, "other", table(
                    7,
                    157,
                    328,
                    0.1,
                    0.9,
                    0.21,
                    314,
                    548,
                    1250,
                    80,
                    12,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 0, table([1, "fix", table(
                [1, "plists", table(
                    "guo_1.png",
                    "guo_2.png",
                    "guo_5.png"
                )],
                [1, "pos", table(
                    [0, cc.p(0, 0)],
                    [0, cc.p(15, 25)],
                    [0, cc.p(-15, -25)]
                )],
                [1, "angle", table(
                    [0, cc.p(30, 150)],
                    [0, cc.p(120, 240)],
                    [0, cc.p(-60, 60)]
                )],
                [1, "other", table(
                    90,
                    220,
                    0.26,
                    300,
                    585,
                    853,
                    80,
                    12
                )]
            )])]
    )],
    [0, table(
        [1, 4, table([1, "fix", table(
                [1, "plists", table("ke_3.png", "yezi_1.png")],
                [1, "pos", table([0, cc.p(0, 0)], [0, cc.p(0, 0)])],
                [1, "angle", table([0, cc.p(60, 120)], [0, cc.p(30, 150)])],
                [1, "other", table(
                    50,
                    190,
                    0.16,
                    210,
                    410,
                    875,
                    80,
                    12
                )]
            )], [1, "random", table([1, "plists", table(
                    "ke_1.png",
                    "ke_4.png",
                    "ke_7.png",
                    "ke_8.png",
                    "ke_9.png"
                )], [1, "other", table(
                    7,
                    40,
                    160,
                    0.1,
                    0.9,
                    0.21,
                    220,
                    384,
                    875,
                    80,
                    12,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 3, table([1, "fix", table(
                [1, "plists", table(
                    "ke_2.png",
                    "yezi_5.png",
                    "yezi_2.png",
                    "ke_10.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(25, -35)]
                )],
                [1, "angle", table(
                    [0, cc.p(120, 220)],
                    [0, cc.p(30, 150)],
                    [0, cc.p(30, 150)],
                    [0, cc.p(-60, 60)]
                )],
                [1, "other", table(
                    50,
                    190,
                    0.16,
                    210,
                    410,
                    875,
                    80,
                    12
                )]
            )], [1, "random", table([1, "plists", table(
                    "ke_1.png",
                    "ke_4.png",
                    "ke_7.png",
                    "ke_8.png",
                    "ke_9.png"
                )], [1, "other", table(
                    7,
                    40,
                    160,
                    0.1,
                    0.9,
                    0.21,
                    220,
                    384,
                    875,
                    80,
                    12,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "fix", table(
                [1, "plists", table(
                    "ke_3.png",
                    "ke_6.png",
                    "ke_5.png",
                    "yezi_4.png",
                    "yezi_3.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(25, 30)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(120, 220)],
                    [0, cc.p(30, 150)],
                    [0, cc.p(-60, 60)],
                    [0, cc.p(30, 150)],
                    [0, cc.p(30, 150)]
                )],
                [1, "other", table(
                    50,
                    190,
                    0.16,
                    210,
                    410,
                    875,
                    80,
                    12
                )]
            )], [1, "random", table([1, "plists", table(
                    "ke_1.png",
                    "ke_4.png",
                    "ke_7.png",
                    "ke_8.png",
                    "ke_9.png"
                )], [1, "other", table(
                    7,
                    40,
                    160,
                    0.1,
                    0.9,
                    0.21,
                    220,
                    384,
                    875,
                    80,
                    12,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "ke_6.png",
                    "ke_5.png",
                    "ke_2.png",
                    "ke_10.png"
                )],
                [1, "pos", table(
                    [0, cc.p(0, 0)],
                    [0, cc.p(15, 25)],
                    [0, cc.p(-15, -25)],
                    [0, cc.p(-15, -25)]
                )],
                [1, "angle", table(
                    [0, cc.p(30, 150)],
                    [0, cc.p(-60, 60)],
                    [0, cc.p(120, 220)],
                    [0, cc.p(-60, 60)]
                )],
                [1, "other", table(
                    50,
                    190,
                    0.16,
                    210,
                    410,
                    875,
                    80,
                    12
                )]
            )], [1, "random", table([1, "plists", table(
                    "ke_1.png",
                    "ke_4.png",
                    "ke_7.png",
                    "ke_8.png",
                    "ke_9.png"
                )], [1, "other", table(
                    7,
                    40,
                    160,
                    0.1,
                    0.9,
                    0.21,
                    220,
                    384,
                    875,
                    80,
                    12,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 0, table([1, "fix", table(
                [1, "plists", table(
                    "guo_1.png",
                    "guo_2.png",
                    "guo_5.png"
                )],
                [1, "pos", table(
                    [0, cc.p(0, 0)],
                    [0, cc.p(15, 25)],
                    [0, cc.p(-15, -25)]
                )],
                [1, "angle", table(
                    [0, cc.p(30, 150)],
                    [0, cc.p(120, 240)],
                    [0, cc.p(-60, 60)]
                )],
                [1, "other", table(
                    48,
                    170,
                    0.3,
                    220,
                    384,
                    700,
                    80,
                    12
                )]
            )])]
    )],
    [0, table(
        [1, 4, table([1, "fix", table(
                [1, "plists", table("ke_3.png", "yezi_1.png")],
                [1, "pos", table([0, cc.p(0, 0)], [0, cc.p(0, 0)])],
                [1, "angle", table([0, cc.p(60, 120)], [0, cc.p(30, 150)])],
                [1, "other", table(
                    43,
                    157,
                    0.18,
                    165,
                    322,
                    688,
                    80,
                    12
                )]
            )], [1, "random", table([1, "plists", table(
                    "ke_1.png",
                    "ke_4.png",
                    "ke_7.png",
                    "ke_8.png",
                    "ke_9.png"
                )], [1, "other", table(
                    7,
                    31,
                    125,
                    0.1,
                    0.9,
                    0.38,
                    173,
                    301,
                    688,
                    80,
                    12,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 3, table([1, "fix", table(
                [1, "plists", table(
                    "ke_2.png",
                    "yezi_5.png",
                    "yezi_2.png",
                    "ke_10.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(25, -35)]
                )],
                [1, "angle", table(
                    [0, cc.p(120, 220)],
                    [0, cc.p(30, 150)],
                    [0, cc.p(30, 150)],
                    [0, cc.p(-60, 60)]
                )],
                [1, "other", table(
                    43,
                    157,
                    0.18,
                    165,
                    322,
                    688,
                    80,
                    12
                )]
            )], [1, "random", table([1, "plists", table(
                    "ke_1.png",
                    "ke_4.png",
                    "ke_7.png",
                    "ke_8.png",
                    "ke_9.png"
                )], [1, "other", table(
                    7,
                    31,
                    125,
                    0.1,
                    0.9,
                    0.38,
                    173,
                    301,
                    688,
                    80,
                    12,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "fix", table(
                [1, "plists", table(
                    "ke_3.png",
                    "ke_6.png",
                    "ke_5.png",
                    "yezi_4.png",
                    "yezi_3.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(25, 30)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(120, 220)],
                    [0, cc.p(30, 150)],
                    [0, cc.p(-60, 60)],
                    [0, cc.p(30, 150)],
                    [0, cc.p(30, 150)]
                )],
                [1, "other", table(
                    43,
                    157,
                    0.18,
                    165,
                    322,
                    688,
                    80,
                    12
                )]
            )], [1, "random", table([1, "plists", table(
                    "ke_1.png",
                    "ke_4.png",
                    "ke_7.png",
                    "ke_8.png",
                    "ke_9.png"
                )], [1, "other", table(
                    7,
                    31,
                    125,
                    0.1,
                    0.9,
                    0.38,
                    173,
                    301,
                    688,
                    80,
                    12,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "ke_6.png",
                    "ke_5.png",
                    "ke_2.png",
                    "ke_10.png"
                )],
                [1, "pos", table(
                    [0, cc.p(0, 0)],
                    [0, cc.p(15, 25)],
                    [0, cc.p(-15, -25)],
                    [0, cc.p(-15, -25)]
                )],
                [1, "angle", table(
                    [0, cc.p(30, 150)],
                    [0, cc.p(-60, 60)],
                    [0, cc.p(120, 220)],
                    [0, cc.p(-60, 60)]
                )],
                [1, "other", table(
                    43,
                    157,
                    0.18,
                    165,
                    322,
                    688,
                    80,
                    12
                )]
            )], [1, "random", table([1, "plists", table(
                    "ke_1.png",
                    "ke_4.png",
                    "ke_7.png",
                    "ke_8.png",
                    "ke_9.png"
                )], [1, "other", table(
                    7,
                    31,
                    125,
                    0.1,
                    0.9,
                    0.38,
                    173,
                    301,
                    688,
                    80,
                    12,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 0, table([1, "fix", table(
                [1, "plists", table(
                    "guo_1.png",
                    "guo_2.png",
                    "guo_5.png"
                )],
                [1, "pos", table(
                    [0, cc.p(0, 0)],
                    [0, cc.p(15, 25)],
                    [0, cc.p(-15, -25)]
                )],
                [1, "angle", table(
                    [0, cc.p(30, 150)],
                    [0, cc.p(120, 240)],
                    [0, cc.p(-60, 60)]
                )],
                [1, "other", table(
                    55,
                    121,
                    0.33,
                    165,
                    322,
                    600,
                    80,
                    12
                )]
            )])]
    )],
    [0, table(
        [1, 4, table([1, "fix", table(
                [1, "plists", table("ke_3.png", "yezi_1.png")],
                [1, "pos", table([0, cc.p(0, 0)], [0, cc.p(0, 0)])],
                [1, "angle", table([0, cc.p(60, 120)], [0, cc.p(30, 150)])],
                [1, "other", table(
                    36,
                    131,
                    0.22,
                    138,
                    269,
                    575,
                    80,
                    12
                )]
            )], [1, "random", table([1, "plists", table(
                    "ke_1.png",
                    "ke_4.png",
                    "ke_7.png",
                    "ke_8.png",
                    "ke_9.png"
                )], [1, "other", table(
                    7,
                    26,
                    105,
                    0.1,
                    0.9,
                    0.46,
                    144,
                    252,
                    575,
                    80,
                    12,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 3, table([1, "fix", table(
                [1, "plists", table(
                    "ke_2.png",
                    "yezi_5.png",
                    "yezi_2.png",
                    "ke_10.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(25, -35)]
                )],
                [1, "angle", table(
                    [0, cc.p(120, 220)],
                    [0, cc.p(30, 150)],
                    [0, cc.p(30, 150)],
                    [0, cc.p(-60, 60)]
                )],
                [1, "other", table(
                    36,
                    131,
                    0.22,
                    138,
                    269,
                    575,
                    80,
                    12
                )]
            )], [1, "random", table([1, "plists", table(
                    "ke_1.png",
                    "ke_4.png",
                    "ke_7.png",
                    "ke_8.png",
                    "ke_9.png"
                )], [1, "other", table(
                    7,
                    26,
                    105,
                    0.1,
                    0.9,
                    0.46,
                    144,
                    252,
                    575,
                    80,
                    12,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "fix", table(
                [1, "plists", table(
                    "ke_3.png",
                    "ke_6.png",
                    "ke_5.png",
                    "yezi_4.png",
                    "yezi_3.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(25, 30)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(120, 220)],
                    [0, cc.p(30, 150)],
                    [0, cc.p(-60, 60)],
                    [0, cc.p(30, 150)],
                    [0, cc.p(30, 150)]
                )],
                [1, "other", table(
                    36,
                    131,
                    0.22,
                    138,
                    269,
                    575,
                    80,
                    12
                )]
            )], [1, "random", table([1, "plists", table(
                    "ke_1.png",
                    "ke_4.png",
                    "ke_7.png",
                    "ke_8.png",
                    "ke_9.png"
                )], [1, "other", table(
                    7,
                    26,
                    105,
                    0.1,
                    0.9,
                    0.46,
                    144,
                    252,
                    575,
                    80,
                    12,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "ke_6.png",
                    "ke_5.png",
                    "ke_2.png",
                    "ke_10.png"
                )],
                [1, "pos", table(
                    [0, cc.p(0, 0)],
                    [0, cc.p(15, 25)],
                    [0, cc.p(-15, -25)],
                    [0, cc.p(-15, -25)]
                )],
                [1, "angle", table(
                    [0, cc.p(30, 150)],
                    [0, cc.p(-60, 60)],
                    [0, cc.p(120, 220)],
                    [0, cc.p(-60, 60)]
                )],
                [1, "other", table(
                    36,
                    131,
                    0.22,
                    138,
                    269,
                    575,
                    80,
                    12
                )]
            )], [1, "random", table([1, "plists", table(
                    "ke_1.png",
                    "ke_4.png",
                    "ke_7.png",
                    "ke_8.png",
                    "ke_9.png"
                )], [1, "other", table(
                    7,
                    26,
                    105,
                    0.1,
                    0.9,
                    0.46,
                    144,
                    252,
                    575,
                    80,
                    12,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 0, table([1, "fix", table(
                [1, "plists", table(
                    "guo_1.png",
                    "guo_2.png",
                    "guo_5.png"
                )],
                [1, "pos", table(
                    [0, cc.p(0, 0)],
                    [0, cc.p(15, 25)],
                    [0, cc.p(-15, -25)]
                )],
                [1, "angle", table(
                    [0, cc.p(30, 150)],
                    [0, cc.p(120, 240)],
                    [0, cc.p(-60, 60)]
                )],
                [1, "other", table(
                    41,
                    100,
                    0.37,
                    138,
                    269,
                    500,
                    80,
                    12
                )]
            )])]
    )]
)
ParticleAnimationConfig.woodboxFlakeFixPosConfig = table(
    [0, table(
        [1, 5, table([1, "fix", table(
                [1, "plists", table("75_muban_1.png")],
                [1, "pos", table([0, cc.p(0, 0)])],
                [1, "angle", table([0, cc.p(70, 110)])],
                [1, "other", table(
                    207,
                    320,
                    0.29,
                    414,
                    485,
                    1550,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "75_muxie_1.png",
                    "75_muxie_2.png",
                    "75_muxie_3.png",
                    "75_muxie_4.png",
                    "75_muxie_5.png",
                    "75_musui_1.png",
                    "75_musui_2.png"
                )], [1, "other", table(
                    4,
                    40,
                    208,
                    0.9,
                    1.2,
                    0.36,
                    371,
                    657,
                    1550,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 4, table([1, "fix", table(
                [1, "plists", table("75_muban_1.png")],
                [1, "pos", table([0, cc.p(0, -25)])],
                [1, "angle", table([0, cc.p(70, 110)])],
                [1, "other", table(
                    207,
                    320,
                    0.29,
                    414,
                    485,
                    1550,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "75_muxie_1.png",
                    "75_muxie_2.png",
                    "75_muxie_3.png",
                    "75_muxie_4.png",
                    "75_muxie_5.png",
                    "75_musui_1.png",
                    "75_musui_2.png"
                )], [1, "other", table(
                    4,
                    40,
                    208,
                    0.9,
                    1.2,
                    0.36,
                    371,
                    657,
                    1550,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 3, table([1, "fix", table(
                [1, "plists", table("75_muban_1.png")],
                [1, "pos", table([0, cc.p(0, 25)])],
                [1, "angle", table([0, cc.p(70, 110)])],
                [1, "other", table(
                    207,
                    320,
                    0.29,
                    414,
                    485,
                    1550,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "75_muxie_1.png",
                    "75_muxie_2.png",
                    "75_muxie_3.png",
                    "75_muxie_4.png",
                    "75_muxie_5.png",
                    "75_musui_1.png",
                    "75_musui_2.png"
                )], [1, "other", table(
                    4,
                    40,
                    208,
                    0.9,
                    1.2,
                    0.36,
                    371,
                    657,
                    1550,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "fix", table(
                [1, "plists", table("75_muban_2.png")],
                [1, "pos", table([0, cc.p(0, 0)])],
                [1, "angle", table([0, cc.p(60, 120)])],
                [1, "other", table(
                    191,
                    282,
                    0.28,
                    385,
                    528,
                    1550,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "75_musui_1.png",
                    "75_musui_2.png",
                    "75_musui_3.png",
                    "75_musui_4.png",
                    "75_musui_5.png",
                    "75_muxie_4.png",
                    "75_muxie_5.png"
                )], [1, "other", table(
                    4,
                    31,
                    128,
                    0.9,
                    1.4,
                    0.31,
                    314,
                    648,
                    1551,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "75_mukuai_1.png",
                    "75_mukuai_2.png",
                    "75_mukuai_3.png",
                    "75_mukuai_4.png",
                    "75_mukuai_6.png",
                    "75_mukuai_8.png",
                    "75_mukuai_9.png",
                    "75_mukuai_10.png",
                    "75_lemon_1.png",
                    "75_lemon_2.png",
                    "75_lemon_3.png",
                    "75_lemon_4.png",
                    "75_lemon_5.png"
                )],
                [1, "pos", table(
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    78,
                    485,
                    0.1,
                    600,
                    785,
                    1550,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "75_muxie_1.png",
                    "75_muxie_2.png",
                    "75_muxie_3.png",
                    "75_muxie_4.png",
                    "75_muxie_5.png",
                    "75_musui_1.png",
                    "75_musui_2.png",
                    "75_musui_3.png",
                    "75_musui_4.png",
                    "75_musui_5.png",
                    "75_mutiao_1.png",
                    "75_mutiao_2.png",
                    "75_mutiao_3.png",
                    "75_mutiao_4.png",
                    "75_mutiao_5.png"
                )], [1, "other", table(
                    4,
                    57,
                    228,
                    0.9,
                    1.4,
                    0.21,
                    314,
                    648,
                    1550,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 11, table([1, "fix", table(
                [1, "plists", table("75_lemon_7.png", "75_lemon_8.png")],
                [1, "pos", table([0, cc.p(0, 0)], [0, cc.p(0, 0)])],
                [1, "angle", table([0, cc.p(90, 115)], [0, cc.p(70, 90)])],
                [1, "scale", table(1.4, 1.4)],
                [1, "other", table(
                    43,
                    266,
                    0.26,
                    330,
                    431,
                    853,
                    75,
                    10
                )]
            )])]
    )],
    [0, table(
        [1, 5, table([1, "fix", table(
                [1, "plists", table("75_muban_1.png")],
                [1, "pos", table([0, cc.p(0, 0)])],
                [1, "angle", table([0, cc.p(70, 110)])],
                [1, "other", table(
                    145,
                    230,
                    0.39,
                    290,
                    340,
                    1085,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "75_muxie_1.png",
                    "75_muxie_2.png",
                    "75_muxie_3.png",
                    "75_muxie_4.png",
                    "75_muxie_5.png",
                    "75_musui_1.png",
                    "75_musui_2.png"
                )], [1, "other", table(
                    4,
                    28,
                    146,
                    0.9,
                    1.2,
                    0.46,
                    260,
                    460,
                    1086,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 4, table([1, "fix", table(
                [1, "plists", table("75_muban_1.png")],
                [1, "pos", table([0, cc.p(0, -25)])],
                [1, "angle", table([0, cc.p(70, 110)])],
                [1, "other", table(
                    145,
                    230,
                    0.39,
                    290,
                    340,
                    1085,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "75_muxie_1.png",
                    "75_muxie_2.png",
                    "75_muxie_3.png",
                    "75_muxie_4.png",
                    "75_muxie_5.png",
                    "75_musui_1.png",
                    "75_musui_2.png"
                )], [1, "other", table(
                    4,
                    28,
                    146,
                    0.9,
                    1.2,
                    0.46,
                    260,
                    460,
                    1086,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 3, table([1, "fix", table(
                [1, "plists", table("75_muban_1.png")],
                [1, "pos", table([0, cc.p(0, 25)])],
                [1, "angle", table([0, cc.p(70, 110)])],
                [1, "other", table(
                    145,
                    230,
                    0.39,
                    290,
                    340,
                    1085,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "75_muxie_1.png",
                    "75_muxie_2.png",
                    "75_muxie_3.png",
                    "75_muxie_4.png",
                    "75_muxie_5.png",
                    "75_musui_1.png",
                    "75_musui_2.png"
                )], [1, "other", table(
                    4,
                    28,
                    146,
                    0.9,
                    1.2,
                    0.46,
                    260,
                    460,
                    1086,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "fix", table(
                [1, "plists", table("75_muban_2.png")],
                [1, "pos", table([0, cc.p(0, 0)])],
                [1, "angle", table([0, cc.p(60, 120)])],
                [1, "other", table(
                    134,
                    198,
                    0.38,
                    270,
                    370,
                    1085,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "75_musui_1.png",
                    "75_musui_2.png",
                    "75_musui_3.png",
                    "75_musui_4.png",
                    "75_musui_5.png",
                    "75_muxie_4.png",
                    "75_muxie_5.png"
                )], [1, "other", table(
                    4,
                    22,
                    90,
                    0.9,
                    1.4,
                    0.41,
                    220,
                    454,
                    1085,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "75_mukuai_1.png",
                    "75_mukuai_2.png",
                    "75_mukuai_3.png",
                    "75_mukuai_4.png",
                    "75_mukuai_6.png",
                    "75_mukuai_8.png",
                    "75_mukuai_9.png",
                    "75_mukuai_10.png",
                    "75_lemon_1.png",
                    "75_lemon_2.png",
                    "75_lemon_3.png",
                    "75_lemon_4.png",
                    "75_lemon_5.png"
                )],
                [1, "pos", table(
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    55,
                    340,
                    0.16,
                    420,
                    550,
                    1085,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "75_muxie_1.png",
                    "75_muxie_2.png",
                    "75_muxie_3.png",
                    "75_muxie_4.png",
                    "75_muxie_5.png",
                    "75_musui_1.png",
                    "75_musui_2.png",
                    "75_musui_3.png",
                    "75_musui_4.png",
                    "75_musui_5.png",
                    "75_mutiao_1.png",
                    "75_mutiao_2.png",
                    "75_mutiao_3.png",
                    "75_mutiao_4.png",
                    "75_mutiao_5.png"
                )], [1, "other", table(
                    4,
                    40,
                    160,
                    0.9,
                    1.4,
                    0.41,
                    220,
                    454,
                    1085,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 11, table([1, "fix", table(
                [1, "plists", table("75_lemon_7.png", "75_lemon_8.png")],
                [1, "pos", table([0, cc.p(0, 0)], [0, cc.p(0, 0)])],
                [1, "angle", table([0, cc.p(90, 115)], [0, cc.p(70, 90)])],
                [1, "scale", table(1.4, 1.4)],
                [1, "other", table(
                    55,
                    340,
                    0.16,
                    420,
                    550,
                    1085,
                    75,
                    10
                )]
            )])]
    )],
    [0, table(
        [1, 5, table([1, "fix", table(
                [1, "plists", table("75_muban_1.png")],
                [1, "pos", table([0, cc.p(0, 0)])],
                [1, "angle", table([0, cc.p(70, 110)])],
                [1, "other", table(
                    114,
                    176,
                    0.49,
                    228,
                    268,
                    852,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "75_muxie_1.png",
                    "75_muxie_2.png",
                    "75_muxie_3.png",
                    "75_muxie_4.png",
                    "75_muxie_5.png",
                    "75_musui_1.png",
                    "75_musui_2.png"
                )], [1, "other", table(
                    4,
                    22,
                    114,
                    0.9,
                    1.2,
                    0.46,
                    204,
                    361,
                    852,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 4, table([1, "fix", table(
                [1, "plists", table("75_muban_1.png")],
                [1, "pos", table([0, cc.p(0, -25)])],
                [1, "angle", table([0, cc.p(70, 110)])],
                [1, "other", table(
                    114,
                    176,
                    0.49,
                    228,
                    268,
                    852,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "75_muxie_1.png",
                    "75_muxie_2.png",
                    "75_muxie_3.png",
                    "75_muxie_4.png",
                    "75_muxie_5.png",
                    "75_musui_1.png",
                    "75_musui_2.png"
                )], [1, "other", table(
                    4,
                    22,
                    114,
                    0.9,
                    1.2,
                    0.46,
                    204,
                    361,
                    852,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 3, table([1, "fix", table(
                [1, "plists", table("75_muban_1.png")],
                [1, "pos", table([0, cc.p(0, 25)])],
                [1, "angle", table([0, cc.p(70, 110)])],
                [1, "other", table(
                    114,
                    176,
                    0.49,
                    228,
                    268,
                    852,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "75_muxie_1.png",
                    "75_muxie_2.png",
                    "75_muxie_3.png",
                    "75_muxie_4.png",
                    "75_muxie_5.png",
                    "75_musui_1.png",
                    "75_musui_2.png"
                )], [1, "other", table(
                    4,
                    22,
                    114,
                    0.9,
                    1.2,
                    0.46,
                    204,
                    361,
                    852,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "fix", table(
                [1, "plists", table("75_muban_2.png")],
                [1, "pos", table([0, cc.p(0, 0)])],
                [1, "angle", table([0, cc.p(60, 120)])],
                [1, "other", table(
                    105,
                    155,
                    0.48,
                    197,
                    290,
                    852,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "75_musui_1.png",
                    "75_musui_2.png",
                    "75_musui_3.png",
                    "75_musui_4.png",
                    "75_musui_5.png",
                    "75_muxie_4.png",
                    "75_muxie_5.png"
                )], [1, "other", table(
                    4,
                    17,
                    70,
                    0.9,
                    1.4,
                    0.41,
                    173,
                    356,
                    853,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "75_mukuai_1.png",
                    "75_mukuai_2.png",
                    "75_mukuai_3.png",
                    "75_mukuai_4.png",
                    "75_mukuai_6.png",
                    "75_mukuai_8.png",
                    "75_mukuai_9.png",
                    "75_mukuai_10.png",
                    "75_lemon_1.png",
                    "75_lemon_2.png",
                    "75_lemon_3.png",
                    "75_lemon_4.png",
                    "75_lemon_5.png"
                )],
                [1, "pos", table(
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    43,
                    266,
                    0.26,
                    330,
                    431,
                    853,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "75_muxie_1.png",
                    "75_muxie_2.png",
                    "75_muxie_3.png",
                    "75_muxie_4.png",
                    "75_muxie_5.png",
                    "75_musui_1.png",
                    "75_musui_2.png",
                    "75_musui_3.png",
                    "75_musui_4.png",
                    "75_musui_5.png",
                    "75_mutiao_1.png",
                    "75_mutiao_2.png",
                    "75_mutiao_3.png",
                    "75_mutiao_4.png",
                    "75_mutiao_5.png"
                )], [1, "other", table(
                    4,
                    31,
                    125,
                    0.9,
                    1.4,
                    0.41,
                    314,
                    648,
                    1550,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 11, table([1, "fix", table(
                [1, "plists", table("75_lemon_7.png", "75_lemon_8.png")],
                [1, "pos", table([0, cc.p(0, 0)], [0, cc.p(0, 0)])],
                [1, "angle", table([0, cc.p(90, 115)], [0, cc.p(70, 90)])],
                [1, "scale", table(1.4, 1.4)],
                [1, "other", table(
                    43,
                    266,
                    0.26,
                    330,
                    431,
                    853,
                    75,
                    10
                )]
            )])]
    )],
    [0, table(
        [1, 5, table([1, "fix", table(
                [1, "plists", table("75_muban_1.png")],
                [1, "pos", table([0, cc.p(0, 0)])],
                [1, "angle", table([0, cc.p(70, 110)])],
                [1, "other", table(
                    95,
                    147,
                    0.59,
                    190,
                    223,
                    713,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "75_muxie_1.png",
                    "75_muxie_2.png",
                    "75_muxie_3.png",
                    "75_muxie_4.png",
                    "75_muxie_5.png",
                    "75_musui_1.png",
                    "75_musui_2.png"
                )], [1, "other", table(
                    4,
                    18.4,
                    96,
                    0.9,
                    1.2,
                    0.61,
                    171,
                    302,
                    713,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 4, table([1, "fix", table(
                [1, "plists", table("75_muban_1.png")],
                [1, "pos", table([0, cc.p(0, -25)])],
                [1, "angle", table([0, cc.p(70, 110)])],
                [1, "other", table(
                    95,
                    147,
                    0.59,
                    190,
                    223,
                    713,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "75_muxie_1.png",
                    "75_muxie_2.png",
                    "75_muxie_3.png",
                    "75_muxie_4.png",
                    "75_muxie_5.png",
                    "75_musui_1.png",
                    "75_musui_2.png"
                )], [1, "other", table(
                    4,
                    18.4,
                    96,
                    0.9,
                    1.2,
                    0.61,
                    171,
                    302,
                    713,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 3, table([1, "fix", table(
                [1, "plists", table("75_muban_1.png")],
                [1, "pos", table([0, cc.p(0, 25)])],
                [1, "angle", table([0, cc.p(70, 110)])],
                [1, "other", table(
                    95,
                    147,
                    0.59,
                    190,
                    223,
                    713,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "75_muxie_1.png",
                    "75_muxie_2.png",
                    "75_muxie_3.png",
                    "75_muxie_4.png",
                    "75_muxie_5.png",
                    "75_musui_1.png",
                    "75_musui_2.png"
                )], [1, "other", table(
                    4,
                    18.4,
                    96,
                    0.9,
                    1.2,
                    0.61,
                    171,
                    302,
                    713,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "fix", table(
                [1, "plists", table("75_muban_2.png")],
                [1, "pos", table([0, cc.p(0, 0)])],
                [1, "angle", table([0, cc.p(60, 120)])],
                [1, "other", table(
                    88,
                    130,
                    0.58,
                    177,
                    243,
                    713,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "75_musui_1.png",
                    "75_musui_2.png",
                    "75_musui_3.png",
                    "75_musui_4.png",
                    "75_musui_5.png",
                    "75_muxie_4.png",
                    "75_muxie_5.png"
                )], [1, "other", table(
                    4,
                    14,
                    59,
                    0.9,
                    1.4,
                    0.61,
                    144,
                    298,
                    713,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "75_mukuai_1.png",
                    "75_mukuai_2.png",
                    "75_mukuai_3.png",
                    "75_mukuai_4.png",
                    "75_mukuai_6.png",
                    "75_mukuai_8.png",
                    "75_mukuai_9.png",
                    "75_mukuai_10.png",
                    "75_lemon_1.png",
                    "75_lemon_2.png",
                    "75_lemon_3.png",
                    "75_lemon_4.png",
                    "75_lemon_5.png"
                )],
                [1, "pos", table(
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    36,
                    223,
                    0.36,
                    276,
                    361,
                    713,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "75_muxie_1.png",
                    "75_muxie_2.png",
                    "75_muxie_3.png",
                    "75_muxie_4.png",
                    "75_muxie_5.png",
                    "75_musui_1.png",
                    "75_musui_2.png",
                    "75_musui_3.png",
                    "75_musui_4.png",
                    "75_musui_5.png",
                    "75_mutiao_1.png",
                    "75_mutiao_2.png",
                    "75_mutiao_3.png",
                    "75_mutiao_4.png",
                    "75_mutiao_5.png"
                )], [1, "other", table(
                    4,
                    26,
                    105,
                    0.9,
                    1.4,
                    0.61,
                    144,
                    298,
                    713,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 11, table([1, "fix", table(
                [1, "plists", table("75_lemon_7.png", "75_lemon_8.png")],
                [1, "pos", table([0, cc.p(0, 0)], [0, cc.p(0, 0)])],
                [1, "angle", table([0, cc.p(90, 115)], [0, cc.p(70, 90)])],
                [1, "scale", table(1.4, 1.4)],
                [1, "other", table(
                    36,
                    223,
                    0.36,
                    276,
                    361,
                    713,
                    75,
                    10
                )]
            )])]
    )]
)
ParticleAnimationConfig.circusFlakeFixPosConfig = table(
    [0, table(
        [1, 6, table([1, "fix", table(
                [1, "plists", table("74_paizid.png")],
                [1, "pos", table([0, cc.p(0, 0)])],
                [1, "angle", table([0, cc.p(70, 110)])],
                [1, "other", table(
                    172,
                    429,
                    0.24,
                    644,
                    1073,
                    2145,
                    75,
                    10
                )]
            )])],
        [1, 5, table([1, "fix", table(
                [1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_4.png",
                    "74_suipian_5.png",
                    "74_suipian_6.png",
                    "74_suipian_2.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_3.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-17, -60)],
                    [0, cc.p(17, -50)],
                    [0, cc.p(-5, -55)],
                    [0, cc.p(5, -55)],
                    [0, cc.p(-12, -58)],
                    [0, cc.p(23, -40)],
                    [0, cc.p(-15, -60)],
                    [0, cc.p(15, -50)],
                    [0, cc.p(-10, -55)],
                    [0, cc.p(10, -55)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(180, 270)],
                    [0, cc.p(180, 270)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(180, 270)],
                    [0, cc.p(270, 360)]
                )],
                [1, "other", table(
                    43,
                    186,
                    0.24,
                    408,
                    658,
                    930,
                    75,
                    10
                )]
            )])],
        [1, 4, table([1, "fix", table(
                [1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_4.png",
                    "74_suipian_5.png",
                    "74_suipian_6.png",
                    "74_suipian_6.png",
                    "74_suipian_2.png",
                    "74_suipian_2.png",
                    "74_suipian_2.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_3.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-22, -30)],
                    [0, cc.p(22, -30)],
                    [0, cc.p(5, -50)],
                    [0, cc.p(-5, -50)],
                    [0, cc.p(-10, -40)],
                    [0, cc.p(10, -40)],
                    [0, cc.p(5, -50)],
                    [0, cc.p(-22, -30)],
                    [0, cc.p(22, -30)],
                    [0, cc.p(5, -50)],
                    [0, cc.p(22, -30)],
                    [0, cc.p(5, -50)],
                    [0, cc.p(-5, -50)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(180, 270)],
                    [0, cc.p(270, 360)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(180, 270)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(180, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(180, 270)],
                    [0, cc.p(270, 360)]
                )],
                [1, "other", table(
                    43,
                    186,
                    0.24,
                    408,
                    658,
                    930,
                    75,
                    10
                )]
            )])],
        [1, 3, table([1, "fix", table(
                [1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_4.png",
                    "74_suipian_5.png",
                    "74_suipian_2.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_3.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-33, -13)],
                    [0, cc.p(-37, -17)],
                    [0, cc.p(-35, -12)],
                    [0, cc.p(-35, -18)],
                    [0, cc.p(-30, -20)],
                    [0, cc.p(-33, -13)],
                    [0, cc.p(-37, -17)],
                    [0, cc.p(-35, -12)],
                    [0, cc.p(-35, -18)]
                )],
                [1, "angle", table(
                    [0, cc.p(60, 120)],
                    [0, cc.p(0, 180)],
                    [0, cc.p(120, 240)],
                    [0, cc.p(300, 420)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(0, 180)],
                    [0, cc.p(120, 240)],
                    [0, cc.p(300, 420)]
                )],
                [1, "other", table(
                    43,
                    186,
                    0.24,
                    408,
                    658,
                    930,
                    75,
                    10
                )]
            )])],
        [1, 2, table([1, "fix", table(
                [1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_4.png",
                    "74_suipian_6.png",
                    "74_suipian_2.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_3.png"
                )],
                [1, "pos", table(
                    [0, cc.p(33, -13)],
                    [0, cc.p(37, -17)],
                    [0, cc.p(35, -12)],
                    [0, cc.p(35, -18)],
                    [0, cc.p(30, -5)],
                    [0, cc.p(33, -13)],
                    [0, cc.p(37, -17)],
                    [0, cc.p(35, -12)],
                    [0, cc.p(35, -18)]
                )],
                [1, "angle", table(
                    [0, cc.p(60, 120)],
                    [0, cc.p(0, 180)],
                    [0, cc.p(120, 240)],
                    [0, cc.p(300, 420)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(0, 180)],
                    [0, cc.p(120, 240)],
                    [0, cc.p(300, 420)]
                )],
                [1, "other", table(
                    43,
                    186,
                    0.24,
                    408,
                    658,
                    930,
                    75,
                    10
                )]
            )])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_2.png",
                    "74_suipian_5.png",
                    "74_suipian_6.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-15, -18)],
                    [0, cc.p(15, -18)],
                    [0, cc.p(-20, -15)],
                    [0, cc.p(20, -15)]
                )],
                [1, "angle", table(
                    [0, cc.p(130, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)]
                )],
                [1, "other", table(
                    43,
                    186,
                    0.24,
                    408,
                    658,
                    930,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_4.png",
                    "74_suipian_5.png"
                )], [1, "other", table(
                    7,
                    43,
                    186,
                    0.35,
                    0.7,
                    0.32,
                    408,
                    658,
                    930,
                    80,
                    15,
                    [0, table([1, "square", 35])]
                )])])],
        [1, 0, table([1, "fix", table(
                [1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_5.png",
                    "74_suipian_6.png"
                )],
                [1, "pos", table(
                    [0, cc.p(0, 13)],
                    [0, cc.p(-10, -2)],
                    [0, cc.p(6, -6)]
                )],
                [1, "angle", table(
                    [0, cc.p(30, 150)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)]
                )],
                [1, "other", table(
                    43,
                    186,
                    0.24,
                    408,
                    658,
                    930,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_4.png",
                    "74_suipian_5.png"
                )], [1, "other", table(
                    13,
                    43,
                    186,
                    0.35,
                    0.85,
                    0.32,
                    408,
                    658,
                    930,
                    80,
                    15,
                    [0, table([1, "square", 35])]
                )])])]
    )],
    [0, table(
        [1, 6, table([1, "fix", table(
                [1, "plists", table("74_paizid.png")],
                [1, "pos", table([0, cc.p(0, 0)])],
                [1, "angle", table([0, cc.p(70, 110)])],
                [1, "other", table(
                    120,
                    300,
                    0.35,
                    450,
                    750,
                    1500,
                    75,
                    10
                )]
            )])],
        [1, 5, table([1, "fix", table(
                [1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_4.png",
                    "74_suipian_5.png",
                    "74_suipian_6.png",
                    "74_suipian_2.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_3.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-17, -60)],
                    [0, cc.p(17, -50)],
                    [0, cc.p(-5, -55)],
                    [0, cc.p(5, -55)],
                    [0, cc.p(-12, -58)],
                    [0, cc.p(23, -40)],
                    [0, cc.p(-15, -60)],
                    [0, cc.p(15, -50)],
                    [0, cc.p(-10, -55)],
                    [0, cc.p(10, -55)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(180, 270)],
                    [0, cc.p(180, 270)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(180, 270)],
                    [0, cc.p(270, 360)]
                )],
                [1, "other", table(
                    30,
                    130,
                    0.35,
                    285,
                    460,
                    650,
                    75,
                    10
                )]
            )])],
        [1, 4, table([1, "fix", table(
                [1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_4.png",
                    "74_suipian_5.png",
                    "74_suipian_6.png",
                    "74_suipian_6.png",
                    "74_suipian_2.png",
                    "74_suipian_2.png",
                    "74_suipian_2.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_3.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-22, -30)],
                    [0, cc.p(22, -30)],
                    [0, cc.p(5, -50)],
                    [0, cc.p(-5, -50)],
                    [0, cc.p(-10, -40)],
                    [0, cc.p(10, -40)],
                    [0, cc.p(5, -50)],
                    [0, cc.p(-22, -30)],
                    [0, cc.p(22, -30)],
                    [0, cc.p(5, -50)],
                    [0, cc.p(22, -30)],
                    [0, cc.p(5, -50)],
                    [0, cc.p(-5, -50)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(180, 270)],
                    [0, cc.p(270, 360)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(180, 270)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(180, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(180, 270)],
                    [0, cc.p(270, 360)]
                )],
                [1, "other", table(
                    30,
                    130,
                    0.35,
                    285,
                    460,
                    650,
                    75,
                    10
                )]
            )])],
        [1, 3, table([1, "fix", table(
                [1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_4.png",
                    "74_suipian_5.png",
                    "74_suipian_2.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_3.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-33, -13)],
                    [0, cc.p(-37, -17)],
                    [0, cc.p(-35, -12)],
                    [0, cc.p(-35, -18)],
                    [0, cc.p(-30, -20)],
                    [0, cc.p(-33, -13)],
                    [0, cc.p(-37, -17)],
                    [0, cc.p(-35, -12)],
                    [0, cc.p(-35, -18)]
                )],
                [1, "angle", table(
                    [0, cc.p(60, 120)],
                    [0, cc.p(0, 180)],
                    [0, cc.p(120, 240)],
                    [0, cc.p(300, 420)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(0, 180)],
                    [0, cc.p(120, 240)],
                    [0, cc.p(300, 420)]
                )],
                [1, "other", table(
                    30,
                    130,
                    0.35,
                    285,
                    460,
                    650,
                    75,
                    10
                )]
            )])],
        [1, 2, table([1, "fix", table(
                [1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_4.png",
                    "74_suipian_6.png",
                    "74_suipian_2.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_3.png"
                )],
                [1, "pos", table(
                    [0, cc.p(33, -13)],
                    [0, cc.p(37, -17)],
                    [0, cc.p(35, -12)],
                    [0, cc.p(35, -18)],
                    [0, cc.p(30, -5)],
                    [0, cc.p(33, -13)],
                    [0, cc.p(37, -17)],
                    [0, cc.p(35, -12)],
                    [0, cc.p(35, -18)]
                )],
                [1, "angle", table(
                    [0, cc.p(60, 120)],
                    [0, cc.p(0, 180)],
                    [0, cc.p(120, 240)],
                    [0, cc.p(300, 420)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(0, 180)],
                    [0, cc.p(120, 240)],
                    [0, cc.p(300, 420)]
                )],
                [1, "other", table(
                    30,
                    130,
                    0.35,
                    285,
                    460,
                    650,
                    75,
                    10
                )]
            )])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_2.png",
                    "74_suipian_5.png",
                    "74_suipian_6.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-15, -18)],
                    [0, cc.p(15, -18)],
                    [0, cc.p(-20, -15)],
                    [0, cc.p(20, -15)]
                )],
                [1, "angle", table(
                    [0, cc.p(130, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)]
                )],
                [1, "other", table(
                    30,
                    130,
                    0.35,
                    285,
                    460,
                    650,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_4.png",
                    "74_suipian_5.png"
                )], [1, "other", table(
                    7,
                    30,
                    130,
                    0.35,
                    0.7,
                    0.46,
                    285,
                    460,
                    650,
                    80,
                    15,
                    [0, table([1, "square", 35])]
                )])])],
        [1, 0, table([1, "fix", table(
                [1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_5.png",
                    "74_suipian_6.png"
                )],
                [1, "pos", table(
                    [0, cc.p(0, 13)],
                    [0, cc.p(-10, -2)],
                    [0, cc.p(6, -6)]
                )],
                [1, "angle", table(
                    [0, cc.p(30, 150)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)]
                )],
                [1, "other", table(
                    30,
                    130,
                    0.35,
                    285,
                    460,
                    650,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_4.png",
                    "74_suipian_5.png"
                )], [1, "other", table(
                    13,
                    30,
                    130,
                    0.35,
                    0.85,
                    0.46,
                    285,
                    460,
                    650,
                    80,
                    15,
                    [0, table([1, "square", 35])]
                )])])]
    )],
    [0, table(
        [1, 6, table([1, "fix", table(
                [1, "plists", table("74_paizid.png")],
                [1, "pos", table([0, cc.p(0, 0)])],
                [1, "angle", table([0, cc.p(70, 110)])],
                [1, "other", table(
                    95,
                    237,
                    0.44,
                    356,
                    593,
                    1185,
                    75,
                    10
                )]
            )])],
        [1, 5, table([1, "fix", table(
                [1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_4.png",
                    "74_suipian_5.png",
                    "74_suipian_6.png",
                    "74_suipian_2.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_3.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-17, -60)],
                    [0, cc.p(17, -50)],
                    [0, cc.p(-5, -55)],
                    [0, cc.p(5, -55)],
                    [0, cc.p(-12, -58)],
                    [0, cc.p(23, -40)],
                    [0, cc.p(-15, -60)],
                    [0, cc.p(15, -50)],
                    [0, cc.p(-10, -55)],
                    [0, cc.p(10, -55)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(180, 270)],
                    [0, cc.p(180, 270)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(180, 270)],
                    [0, cc.p(270, 360)]
                )],
                [1, "other", table(
                    24,
                    103,
                    0.44,
                    225,
                    363,
                    514,
                    75,
                    10
                )]
            )])],
        [1, 4, table([1, "fix", table(
                [1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_4.png",
                    "74_suipian_5.png",
                    "74_suipian_6.png",
                    "74_suipian_6.png",
                    "74_suipian_2.png",
                    "74_suipian_2.png",
                    "74_suipian_2.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_3.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-22, -30)],
                    [0, cc.p(22, -30)],
                    [0, cc.p(5, -50)],
                    [0, cc.p(-5, -50)],
                    [0, cc.p(-10, -40)],
                    [0, cc.p(10, -40)],
                    [0, cc.p(5, -50)],
                    [0, cc.p(-22, -30)],
                    [0, cc.p(22, -30)],
                    [0, cc.p(5, -50)],
                    [0, cc.p(22, -30)],
                    [0, cc.p(5, -50)],
                    [0, cc.p(-5, -50)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(180, 270)],
                    [0, cc.p(270, 360)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(180, 270)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(180, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(180, 270)],
                    [0, cc.p(270, 360)]
                )],
                [1, "other", table(
                    24,
                    103,
                    0.44,
                    225,
                    363,
                    514,
                    75,
                    10
                )]
            )])],
        [1, 3, table([1, "fix", table(
                [1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_4.png",
                    "74_suipian_5.png",
                    "74_suipian_2.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_3.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-33, -13)],
                    [0, cc.p(-37, -17)],
                    [0, cc.p(-35, -12)],
                    [0, cc.p(-35, -18)],
                    [0, cc.p(-30, -20)],
                    [0, cc.p(-33, -13)],
                    [0, cc.p(-37, -17)],
                    [0, cc.p(-35, -12)],
                    [0, cc.p(-35, -18)]
                )],
                [1, "angle", table(
                    [0, cc.p(60, 120)],
                    [0, cc.p(0, 180)],
                    [0, cc.p(120, 240)],
                    [0, cc.p(300, 420)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(0, 180)],
                    [0, cc.p(120, 240)],
                    [0, cc.p(300, 420)]
                )],
                [1, "other", table(
                    24,
                    103,
                    0.44,
                    225,
                    363,
                    514,
                    75,
                    10
                )]
            )])],
        [1, 2, table([1, "fix", table(
                [1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_4.png",
                    "74_suipian_6.png",
                    "74_suipian_2.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_3.png"
                )],
                [1, "pos", table(
                    [0, cc.p(33, -13)],
                    [0, cc.p(37, -17)],
                    [0, cc.p(35, -12)],
                    [0, cc.p(35, -18)],
                    [0, cc.p(30, -5)],
                    [0, cc.p(33, -13)],
                    [0, cc.p(37, -17)],
                    [0, cc.p(35, -12)],
                    [0, cc.p(35, -18)]
                )],
                [1, "angle", table(
                    [0, cc.p(60, 120)],
                    [0, cc.p(0, 180)],
                    [0, cc.p(120, 240)],
                    [0, cc.p(300, 420)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(0, 180)],
                    [0, cc.p(120, 240)],
                    [0, cc.p(300, 420)]
                )],
                [1, "other", table(
                    24,
                    103,
                    0.44,
                    225,
                    363,
                    514,
                    75,
                    10
                )]
            )])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_2.png",
                    "74_suipian_5.png",
                    "74_suipian_6.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-15, -18)],
                    [0, cc.p(15, -18)],
                    [0, cc.p(-20, -15)],
                    [0, cc.p(20, -15)]
                )],
                [1, "angle", table(
                    [0, cc.p(130, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)]
                )],
                [1, "other", table(
                    24,
                    103,
                    0.44,
                    225,
                    363,
                    514,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_4.png",
                    "74_suipian_5.png"
                )], [1, "other", table(
                    7,
                    24,
                    103,
                    0.35,
                    0.7,
                    0.58,
                    225,
                    363,
                    514,
                    80,
                    15,
                    [0, table([1, "square", 35])]
                )])])],
        [1, 0, table([1, "fix", table(
                [1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_5.png",
                    "74_suipian_6.png"
                )],
                [1, "pos", table(
                    [0, cc.p(0, 13)],
                    [0, cc.p(-10, -2)],
                    [0, cc.p(6, -6)]
                )],
                [1, "angle", table(
                    [0, cc.p(30, 150)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)]
                )],
                [1, "other", table(
                    24,
                    103,
                    0.44,
                    225,
                    363,
                    514,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_4.png",
                    "74_suipian_5.png"
                )], [1, "other", table(
                    13,
                    24,
                    103,
                    0.35,
                    0.85,
                    0.58,
                    225,
                    363,
                    514,
                    80,
                    15,
                    [0, table([1, "square", 35])]
                )])])]
    )],
    [0, table(
        [1, 6, table([1, "fix", table(
                [1, "plists", table("74_paizid.png")],
                [1, "pos", table([0, cc.p(0, 0)])],
                [1, "angle", table([0, cc.p(70, 110)])],
                [1, "other", table(
                    78,
                    195,
                    0.54,
                    293,
                    488,
                    975,
                    75,
                    10
                )]
            )])],
        [1, 5, table([1, "fix", table(
                [1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_4.png",
                    "74_suipian_5.png",
                    "74_suipian_6.png",
                    "74_suipian_2.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_3.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-17, -60)],
                    [0, cc.p(17, -50)],
                    [0, cc.p(-5, -55)],
                    [0, cc.p(5, -55)],
                    [0, cc.p(-12, -58)],
                    [0, cc.p(23, -40)],
                    [0, cc.p(-15, -60)],
                    [0, cc.p(15, -50)],
                    [0, cc.p(-10, -55)],
                    [0, cc.p(10, -55)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(180, 270)],
                    [0, cc.p(180, 270)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(180, 270)],
                    [0, cc.p(270, 360)]
                )],
                [1, "other", table(
                    20,
                    85,
                    0.54,
                    185,
                    299,
                    423,
                    75,
                    10
                )]
            )])],
        [1, 4, table([1, "fix", table(
                [1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_4.png",
                    "74_suipian_5.png",
                    "74_suipian_6.png",
                    "74_suipian_6.png",
                    "74_suipian_2.png",
                    "74_suipian_2.png",
                    "74_suipian_2.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_3.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-22, -30)],
                    [0, cc.p(22, -30)],
                    [0, cc.p(5, -50)],
                    [0, cc.p(-5, -50)],
                    [0, cc.p(-10, -40)],
                    [0, cc.p(10, -40)],
                    [0, cc.p(5, -50)],
                    [0, cc.p(-22, -30)],
                    [0, cc.p(22, -30)],
                    [0, cc.p(5, -50)],
                    [0, cc.p(22, -30)],
                    [0, cc.p(5, -50)],
                    [0, cc.p(-5, -50)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(180, 270)],
                    [0, cc.p(270, 360)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(180, 270)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(180, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(180, 270)],
                    [0, cc.p(270, 360)]
                )],
                [1, "other", table(
                    20,
                    85,
                    0.54,
                    185,
                    299,
                    423,
                    75,
                    10
                )]
            )])],
        [1, 3, table([1, "fix", table(
                [1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_4.png",
                    "74_suipian_5.png",
                    "74_suipian_2.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_3.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-33, -13)],
                    [0, cc.p(-37, -17)],
                    [0, cc.p(-35, -12)],
                    [0, cc.p(-35, -18)],
                    [0, cc.p(-30, -20)],
                    [0, cc.p(-33, -13)],
                    [0, cc.p(-37, -17)],
                    [0, cc.p(-35, -12)],
                    [0, cc.p(-35, -18)]
                )],
                [1, "angle", table(
                    [0, cc.p(60, 120)],
                    [0, cc.p(0, 180)],
                    [0, cc.p(120, 240)],
                    [0, cc.p(300, 420)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(0, 180)],
                    [0, cc.p(120, 240)],
                    [0, cc.p(300, 420)]
                )],
                [1, "other", table(
                    20,
                    85,
                    0.54,
                    185,
                    299,
                    423,
                    75,
                    10
                )]
            )])],
        [1, 2, table([1, "fix", table(
                [1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_4.png",
                    "74_suipian_6.png",
                    "74_suipian_2.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_3.png"
                )],
                [1, "pos", table(
                    [0, cc.p(33, -13)],
                    [0, cc.p(37, -17)],
                    [0, cc.p(35, -12)],
                    [0, cc.p(35, -18)],
                    [0, cc.p(30, -5)],
                    [0, cc.p(33, -13)],
                    [0, cc.p(37, -17)],
                    [0, cc.p(35, -12)],
                    [0, cc.p(35, -18)]
                )],
                [1, "angle", table(
                    [0, cc.p(60, 120)],
                    [0, cc.p(0, 180)],
                    [0, cc.p(120, 240)],
                    [0, cc.p(300, 420)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(0, 180)],
                    [0, cc.p(120, 240)],
                    [0, cc.p(300, 420)]
                )],
                [1, "other", table(
                    20,
                    85,
                    0.54,
                    185,
                    299,
                    423,
                    75,
                    10
                )]
            )])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_2.png",
                    "74_suipian_5.png",
                    "74_suipian_6.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-15, -18)],
                    [0, cc.p(15, -18)],
                    [0, cc.p(-20, -15)],
                    [0, cc.p(20, -15)]
                )],
                [1, "angle", table(
                    [0, cc.p(130, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)]
                )],
                [1, "other", table(
                    20,
                    85,
                    0.54,
                    185,
                    299,
                    423,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_4.png",
                    "74_suipian_5.png"
                )], [1, "other", table(
                    7,
                    20,
                    85,
                    0.35,
                    0.7,
                    0.71,
                    185,
                    299,
                    423,
                    80,
                    15,
                    [0, table([1, "square", 35])]
                )])])],
        [1, 0, table([1, "fix", table(
                [1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_5.png",
                    "74_suipian_6.png"
                )],
                [1, "pos", table(
                    [0, cc.p(0, 13)],
                    [0, cc.p(-10, -2)],
                    [0, cc.p(6, -6)]
                )],
                [1, "angle", table(
                    [0, cc.p(30, 150)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)]
                )],
                [1, "other", table(
                    20,
                    85,
                    0.54,
                    185,
                    299,
                    423,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "74_suipian_1.png",
                    "74_suipian_2.png",
                    "74_suipian_3.png",
                    "74_suipian_4.png",
                    "74_suipian_5.png"
                )], [1, "other", table(
                    13,
                    20,
                    85,
                    0.35,
                    0.85,
                    0.71,
                    185,
                    299,
                    423,
                    80,
                    15,
                    [0, table([1, "square", 35])]
                )])])]
    )]
)
ParticleAnimationConfig.circusBallFlakeFixPosConfig = table(
    [0, table([1, 2, table([1, "fix", table(
                [1, "plists", table("74b_circus_Ball_2.png")],
                [1, "pos", table([0, cc.p(0, 0)])],
                [1, "angle", table([0, cc.p(70, 110)])],
                [1, "other", table(
                    172,
                    429,
                    0.23,
                    644,
                    1073,
                    1859,
                    75,
                    10
                )]
            )])], [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "74b_suipian1.png",
                    "74b_suipian3.png",
                    "74b_suipian5.png",
                    "74b_suipian6.png",
                    "74b_suipian7.png",
                    "74b_suipian8.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-20, 20)],
                    [0, cc.p(20, 20)],
                    [0, cc.p(-30, 0)],
                    [0, cc.p(-15, -30)],
                    [0, cc.p(15, -20)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(180, 360)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(0, 180)]
                )],
                [1, "other", table(
                    46,
                    196,
                    0.24,
                    551,
                    801,
                    1216,
                    80,
                    15
                )]
            )], [1, "random", table([1, "plists", table(
                    "74b_suipian2.png",
                    "74b_suipian4.png",
                    "74b_suipian9.png"
                )], [1, "other", table(
                    5,
                    46,
                    196,
                    0.35,
                    0.85,
                    0.32,
                    551,
                    801,
                    1216,
                    80,
                    15,
                    [0, table([1, "square", 35])]
                )])])])],
    [0, table([1, 2, table([1, "fix", table(
                [1, "plists", table("74b_circus_Ball_2.png")],
                [1, "pos", table([0, cc.p(0, 0)])],
                [1, "angle", table([0, cc.p(70, 110)])],
                [1, "other", table(
                    120,
                    300,
                    0.33,
                    450,
                    750,
                    1300,
                    75,
                    10
                )]
            )])], [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "74b_suipian1.png",
                    "74b_suipian3.png",
                    "74b_suipian5.png",
                    "74b_suipian6.png",
                    "74b_suipian7.png",
                    "74b_suipian8.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-20, 20)],
                    [0, cc.p(20, 20)],
                    [0, cc.p(-30, 0)],
                    [0, cc.p(-15, -30)],
                    [0, cc.p(15, -20)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(180, 360)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(0, 180)]
                )],
                [1, "other", table(
                    32,
                    137,
                    0.35,
                    385,
                    560,
                    850,
                    80,
                    15
                )]
            )], [1, "random", table([1, "plists", table(
                    "74b_suipian2.png",
                    "74b_suipian4.png",
                    "74b_suipian9.png"
                )], [1, "other", table(
                    5,
                    32,
                    137,
                    0.35,
                    0.85,
                    0.46,
                    385,
                    560,
                    850,
                    80,
                    15,
                    [0, table([1, "square", 35])]
                )])])])],
    [0, table([1, 2, table([1, "fix", table(
                [1, "plists", table("74b_circus_Ball_2.png")],
                [1, "pos", table([0, cc.p(0, 0)])],
                [1, "angle", table([0, cc.p(70, 110)])],
                [1, "other", table(
                    95,
                    237,
                    0.42,
                    356,
                    593,
                    1027,
                    75,
                    10
                )]
            )])], [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "74b_suipian1.png",
                    "74b_suipian3.png",
                    "74b_suipian5.png",
                    "74b_suipian6.png",
                    "74b_suipian7.png",
                    "74b_suipian8.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-20, 20)],
                    [0, cc.p(20, 20)],
                    [0, cc.p(-30, 0)],
                    [0, cc.p(-15, -30)],
                    [0, cc.p(15, -20)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(180, 360)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(0, 180)]
                )],
                [1, "other", table(
                    25,
                    108,
                    0.44,
                    304,
                    442,
                    672,
                    80,
                    15
                )]
            )], [1, "random", table([1, "plists", table(
                    "74b_suipian2.png",
                    "74b_suipian4.png",
                    "74b_suipian9.png"
                )], [1, "other", table(
                    5,
                    25,
                    108,
                    0.35,
                    0.85,
                    0.58,
                    304,
                    442,
                    672,
                    80,
                    15,
                    [0, table([1, "square", 35])]
                )])])])],
    [0, table([1, 2, table([1, "fix", table(
                [1, "plists", table("74b_circus_Ball_2.png")],
                [1, "pos", table([0, cc.p(0, 0)])],
                [1, "angle", table([0, cc.p(70, 110)])],
                [1, "other", table(
                    78,
                    195,
                    0.51,
                    293,
                    488,
                    845,
                    75,
                    10
                )]
            )])], [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "74b_suipian1.png",
                    "74b_suipian3.png",
                    "74b_suipian5.png",
                    "74b_suipian6.png",
                    "74b_suipian7.png",
                    "74b_suipian8.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-20, 20)],
                    [0, cc.p(20, 20)],
                    [0, cc.p(-30, 0)],
                    [0, cc.p(-15, -30)],
                    [0, cc.p(15, -20)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(180, 360)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(0, 180)]
                )],
                [1, "other", table(
                    21,
                    89,
                    0.54,
                    250,
                    364,
                    553,
                    80,
                    15
                )]
            )], [1, "random", table([1, "plists", table(
                    "74b_suipian2.png",
                    "74b_suipian4.png",
                    "74b_suipian9.png"
                )], [1, "other", table(
                    5,
                    21,
                    89,
                    0.35,
                    0.85,
                    0.71,
                    250,
                    364,
                    553,
                    80,
                    15,
                    [0, table([1, "square", 35])]
                )])])])]
)
ParticleAnimationConfig.safeFlakeFixPosConfig = table(
    [0, table(
        [1, 12, table([1, "fix", table(
                [1, "plists", table("73_lunzi.png")],
                [1, "pos", table([0, cc.p(0, 0)])],
                [1, "angle", table([0, cc.p(40, 130)])],
                [1, "other", table(
                    320,
                    320,
                    0.17,
                    480,
                    640,
                    2300,
                    75,
                    10
                )]
            )])],
        [1, 11, table([1, "random", table([1, "plists", table(
                    "yuanpansuipian1_1.png",
                    "yuanpansuipian1_2.png",
                    "yuanpansuipian1_3.png",
                    "yuanpansuipian1_4.png",
                    "yuanpansuipian1_5.png",
                    "yuanpansuipian1_6.png",
                    "yuanpansuipian1_7.png"
                )], [1, "other", table(
                    40,
                    20,
                    250,
                    0.2,
                    1,
                    0.22,
                    650,
                    850,
                    1500,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])],
        [1, 10, table([1, "fix", table(
                [1, "plists", table(
                    "yuanpansuipian2_1.png",
                    "yuanpansuipian2_2.png",
                    "yuanpansuipian2_3.png",
                    "yuanpansuipian2_4.png",
                    "yuanpansuipian2_6.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-9, 26)],
                    [0, cc.p(26, 26)],
                    [0, cc.p(26, -9)],
                    [0, cc.p(-9, -26)],
                    [0, cc.p(-44, -53)],
                    [0, cc.p(-35, 17.5)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 150)],
                    [0, cc.p(30, 90)],
                    [0, cc.p(270, 400)],
                    [0, cc.p(220, 270)],
                    [0, cc.p(150, 220)]
                )],
                [1, "other", table(
                    120,
                    300,
                    0.22,
                    450,
                    750,
                    1500,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "yuanpansuipian2_5.png",
                    "yuanpansuipian2_7.png",
                    "yuanpansuipian2_8.png",
                    "yuanpansuipian2_9.png"
                )], [1, "other", table(
                    35,
                    20,
                    250,
                    0.5,
                    0.85,
                    0.24,
                    750,
                    950,
                    1400,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])],
        [1, 9, table([1, "random", table([1, "plists", table(
                    "gaizisuipian_1.png",
                    "gaizisuipian_2.png",
                    "gaizisuipian_3.png",
                    "gaizisuipian_4.png",
                    "gaizisuipian_5.png",
                    "gaizisuipian_6.png",
                    "gaizisuipian_7.png"
                )], [1, "other", table(
                    30,
                    40,
                    220,
                    0.5,
                    0.85,
                    0.22,
                    750,
                    950,
                    1400,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])],
        [1, 8, table([1, "fix", table(
                [1, "plists", table(
                    "dsp_1.png",
                    "dsp_2.png",
                    "dsp_3.png",
                    "dsp_4.png",
                    "dsp_10.png",
                    "dsp_11.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-53, -61)],
                    [0, cc.p(61, -53)],
                    [0, cc.p(79, 61)],
                    [0, cc.p(-53, 61)],
                    [0, cc.p(-79, 9)],
                    [0, cc.p(17.5, 53)]
                )],
                [1, "angle", table(
                    [0, cc.p(270, 450)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(90, 270)]
                )],
                [1, "other", table(
                    50,
                    270,
                    0.22,
                    400,
                    650,
                    1500,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "dsp_6.png",
                    "dsp_7.png",
                    "dsp_8.png",
                    "dsp_9.png",
                    "dsp_12.png",
                    "dsp_13.png",
                    "dsp_14.png"
                )], [1, "other", table(
                    35,
                    100,
                    220,
                    0.5,
                    0.85,
                    0.24,
                    750,
                    950,
                    1400,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "xiangzisuipian_1.png",
                    "xiangzisuipian_2.png",
                    "xiangzisuipian_3.png",
                    "xiangzisuipian_4.png",
                    "xiangzisuipian_6.png",
                    "xiangzisuipian_7.png",
                    "xiangzisuipian_8.png",
                    "xiangzisuipian_9.png",
                    "xiangzisuipian_11.png",
                    "xiangzisuipian_14.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-53, 70)],
                    [0, cc.p(0, 70)],
                    [0, cc.p(79, 61)],
                    [0, cc.p(61, -61)],
                    [0, cc.p(-61, -70)],
                    [0, cc.p(9, -70)],
                    [0, cc.p(79, 0)],
                    [0, cc.p(-79, 26)],
                    [0, cc.p(26, 26)],
                    [0, cc.p(9, -9)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)]
                )],
                [1, "other", table(
                    150,
                    300,
                    0.22,
                    450,
                    750,
                    1500,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "xiangzisuipian_5.png",
                    "xiangzisuipian_10.png",
                    "xiangzisuipian_12.png",
                    "xiangzisuipian_13.png",
                    "xiangzisuipian_15.png",
                    "xiangzisuipian_16.png",
                    "xiangzisuipian_17.png"
                )], [1, "other", table(
                    45,
                    40,
                    220,
                    0.3,
                    1,
                    0.24,
                    750,
                    950,
                    1400,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])]
    )],
    [0, table(
        [1, 12, table([1, "fix", table(
                [1, "plists", table("73_lunzi.png")],
                [1, "pos", table([0, cc.p(0, 0)])],
                [1, "angle", table([0, cc.p(40, 130)])],
                [1, "other", table(
                    224,
                    224,
                    0.25,
                    336,
                    448,
                    1610,
                    75,
                    10
                )]
            )])],
        [1, 11, table([1, "random", table([1, "plists", table(
                    "yuanpansuipian1_1.png",
                    "yuanpansuipian1_2.png",
                    "yuanpansuipian1_3.png",
                    "yuanpansuipian1_4.png",
                    "yuanpansuipian1_5.png",
                    "yuanpansuipian1_6.png",
                    "yuanpansuipian1_7.png"
                )], [1, "other", table(
                    40,
                    14,
                    175,
                    0.2,
                    1,
                    0.26,
                    455,
                    595,
                    1050,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])],
        [1, 10, table([1, "fix", table(
                [1, "plists", table(
                    "yuanpansuipian2_1.png",
                    "yuanpansuipian2_2.png",
                    "yuanpansuipian2_3.png",
                    "yuanpansuipian2_4.png",
                    "yuanpansuipian2_6.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-9, 26)],
                    [0, cc.p(26, 26)],
                    [0, cc.p(26, -9)],
                    [0, cc.p(-9, -26)],
                    [0, cc.p(-44, -53)],
                    [0, cc.p(-35, 17.5)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 150)],
                    [0, cc.p(30, 90)],
                    [0, cc.p(270, 400)],
                    [0, cc.p(220, 270)],
                    [0, cc.p(150, 220)]
                )],
                [1, "other", table(
                    84,
                    210,
                    0.33,
                    315,
                    525,
                    1050,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "yuanpansuipian2_5.png",
                    "yuanpansuipian2_7.png",
                    "yuanpansuipian2_8.png",
                    "yuanpansuipian2_9.png"
                )], [1, "other", table(
                    35,
                    14,
                    175,
                    0.5,
                    0.85,
                    0.36,
                    525,
                    665,
                    980,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])],
        [1, 9, table([1, "random", table([1, "plists", table(
                    "gaizisuipian_1.png",
                    "gaizisuipian_2.png",
                    "gaizisuipian_3.png",
                    "gaizisuipian_4.png",
                    "gaizisuipian_5.png",
                    "gaizisuipian_6.png",
                    "gaizisuipian_7.png"
                )], [1, "other", table(
                    30,
                    28,
                    154,
                    0.5,
                    0.85,
                    0.33,
                    525,
                    665,
                    980,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])],
        [1, 8, table([1, "fix", table(
                [1, "plists", table(
                    "dsp_1.png",
                    "dsp_2.png",
                    "dsp_3.png",
                    "dsp_4.png",
                    "dsp_10.png",
                    "dsp_11.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-53, -61)],
                    [0, cc.p(61, -53)],
                    [0, cc.p(79, 61)],
                    [0, cc.p(-53, 61)],
                    [0, cc.p(-79, 9)],
                    [0, cc.p(17.5, 53)]
                )],
                [1, "angle", table(
                    [0, cc.p(270, 450)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(90, 270)]
                )],
                [1, "other", table(
                    35,
                    189,
                    0.33,
                    280,
                    455,
                    1050,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "dsp_6.png",
                    "dsp_7.png",
                    "dsp_8.png",
                    "dsp_9.png",
                    "dsp_12.png",
                    "dsp_13.png",
                    "dsp_14.png"
                )], [1, "other", table(
                    35,
                    70,
                    154,
                    0.5,
                    0.85,
                    0.36,
                    525,
                    665,
                    980,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "xiangzisuipian_1.png",
                    "xiangzisuipian_2.png",
                    "xiangzisuipian_3.png",
                    "xiangzisuipian_4.png",
                    "xiangzisuipian_6.png",
                    "xiangzisuipian_7.png",
                    "xiangzisuipian_8.png",
                    "xiangzisuipian_9.png",
                    "xiangzisuipian_11.png",
                    "xiangzisuipian_14.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-53, 70)],
                    [0, cc.p(0, 70)],
                    [0, cc.p(79, 61)],
                    [0, cc.p(61, -61)],
                    [0, cc.p(-61, -70)],
                    [0, cc.p(9, -70)],
                    [0, cc.p(79, 0)],
                    [0, cc.p(-79, 26)],
                    [0, cc.p(26, 26)],
                    [0, cc.p(9, -9)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)]
                )],
                [1, "other", table(
                    105,
                    210,
                    0.35,
                    315,
                    525,
                    1050,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "xiangzisuipian_5.png",
                    "xiangzisuipian_10.png",
                    "xiangzisuipian_12.png",
                    "xiangzisuipian_13.png"
                )], [1, "other", table(
                    45,
                    28,
                    154,
                    0.35,
                    1,
                    0.29,
                    525,
                    665,
                    980,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])]
    )],
    [0, table(
        [1, 12, table([1, "fix", table(
                [1, "plists", table("73_lunzi.png")],
                [1, "pos", table([0, cc.p(0, 0)])],
                [1, "angle", table([0, cc.p(40, 130)])],
                [1, "other", table(
                    176,
                    176,
                    0.36,
                    264,
                    352,
                    1265,
                    75,
                    10
                )]
            )])],
        [1, 11, table([1, "random", table([1, "plists", table(
                    "yuanpansuipian1_1.png",
                    "yuanpansuipian1_2.png",
                    "yuanpansuipian1_3.png",
                    "yuanpansuipian1_4.png",
                    "yuanpansuipian1_5.png",
                    "yuanpansuipian1_6.png",
                    "yuanpansuipian1_7.png"
                )], [1, "other", table(
                    40,
                    11,
                    138,
                    0.2,
                    1,
                    0.4,
                    358,
                    468,
                    825,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])],
        [1, 10, table([1, "fix", table(
                [1, "plists", table(
                    "yuanpansuipian2_1.png",
                    "yuanpansuipian2_2.png",
                    "yuanpansuipian2_3.png",
                    "yuanpansuipian2_4.png",
                    "yuanpansuipian2_6.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-9, 26)],
                    [0, cc.p(26, 26)],
                    [0, cc.p(26, -9)],
                    [0, cc.p(-9, -26)],
                    [0, cc.p(-44, -53)],
                    [0, cc.p(-35, 17.5)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 150)],
                    [0, cc.p(30, 90)],
                    [0, cc.p(270, 400)],
                    [0, cc.p(220, 270)],
                    [0, cc.p(150, 220)]
                )],
                [1, "other", table(
                    66,
                    165,
                    0.4,
                    275,
                    413,
                    825,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "yuanpansuipian2_5.png",
                    "yuanpansuipian2_7.png",
                    "yuanpansuipian2_8.png",
                    "yuanpansuipian2_9.png"
                )], [1, "other", table(
                    35,
                    11,
                    138,
                    0.5,
                    0.85,
                    0.45,
                    413,
                    523,
                    770,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])],
        [1, 9, table([1, "random", table([1, "plists", table(
                    "gaizisuipian_1.png",
                    "gaizisuipian_2.png",
                    "gaizisuipian_3.png",
                    "gaizisuipian_4.png",
                    "gaizisuipian_5.png",
                    "gaizisuipian_6.png",
                    "gaizisuipian_7.png"
                )], [1, "other", table(
                    30,
                    22,
                    121,
                    0.5,
                    0.85,
                    0.4,
                    413,
                    523,
                    770,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])],
        [1, 8, table([1, "fix", table(
                [1, "plists", table(
                    "dsp_1.png",
                    "dsp_2.png",
                    "dsp_3.png",
                    "dsp_4.png",
                    "dsp_10.png",
                    "dsp_11.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-53, -61)],
                    [0, cc.p(61, -53)],
                    [0, cc.p(79, 61)],
                    [0, cc.p(-53, 61)],
                    [0, cc.p(-79, 9)],
                    [0, cc.p(17.5, 53)]
                )],
                [1, "angle", table(
                    [0, cc.p(270, 450)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(90, 270)]
                )],
                [1, "other", table(
                    28,
                    149,
                    0.4,
                    220,
                    358,
                    825,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "dsp_6.png",
                    "dsp_7.png",
                    "dsp_8.png",
                    "dsp_9.png",
                    "dsp_12.png",
                    "dsp_13.png",
                    "dsp_14.png"
                )], [1, "other", table(
                    35,
                    55,
                    121,
                    0.5,
                    0.85,
                    0.45,
                    248,
                    413,
                    770,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "xiangzisuipian_1.png",
                    "xiangzisuipian_2.png",
                    "xiangzisuipian_3.png",
                    "xiangzisuipian_4.png",
                    "xiangzisuipian_6.png",
                    "xiangzisuipian_7.png",
                    "xiangzisuipian_8.png",
                    "xiangzisuipian_9.png",
                    "xiangzisuipian_11.png",
                    "xiangzisuipian_14.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-53, 70)],
                    [0, cc.p(0, 70)],
                    [0, cc.p(79, 61)],
                    [0, cc.p(61, -61)],
                    [0, cc.p(-61, -70)],
                    [0, cc.p(9, -70)],
                    [0, cc.p(79, 0)],
                    [0, cc.p(-79, 26)],
                    [0, cc.p(26, 26)],
                    [0, cc.p(9, -9)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)]
                )],
                [1, "other", table(
                    83,
                    165,
                    0.55,
                    248,
                    413,
                    825,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "xiangzisuipian_5.png",
                    "xiangzisuipian_10.png",
                    "xiangzisuipian_12.png",
                    "xiangzisuipian_13.png"
                )], [1, "other", table(
                    45,
                    22,
                    121,
                    0.55,
                    1,
                    0.13,
                    413,
                    523,
                    770,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])]
    )],
    [0, table(
        [1, 12, table([1, "fix", table(
                [1, "plists", table("73_lunzi.png")],
                [1, "pos", table([0, cc.p(0, 0)])],
                [1, "angle", table([0, cc.p(40, 130)])],
                [1, "other", table(
                    147,
                    147,
                    0.48,
                    221,
                    294,
                    1058,
                    75,
                    10
                )]
            )])],
        [1, 11, table([1, "random", table([1, "plists", table(
                    "yuanpansuipian1_1.png",
                    "yuanpansuipian1_2.png",
                    "yuanpansuipian1_3.png",
                    "yuanpansuipian1_4.png",
                    "yuanpansuipian1_5.png",
                    "yuanpansuipian1_6.png",
                    "yuanpansuipian1_7.png"
                )], [1, "other", table(
                    40,
                    9,
                    115,
                    0.2,
                    1,
                    0.65,
                    299,
                    391,
                    690,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])],
        [1, 10, table([1, "fix", table(
                [1, "plists", table(
                    "yuanpansuipian2_1.png",
                    "yuanpansuipian2_2.png",
                    "yuanpansuipian2_3.png",
                    "yuanpansuipian2_4.png",
                    "yuanpansuipian2_6.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-9, 26)],
                    [0, cc.p(26, 26)],
                    [0, cc.p(26, -9)],
                    [0, cc.p(-9, -26)],
                    [0, cc.p(-44, -53)],
                    [0, cc.p(-35, 17.5)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 150)],
                    [0, cc.p(30, 90)],
                    [0, cc.p(270, 400)],
                    [0, cc.p(220, 270)],
                    [0, cc.p(150, 220)]
                )],
                [1, "other", table(
                    55,
                    138,
                    0.65,
                    207,
                    345,
                    690,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "yuanpansuipian2_5.png",
                    "yuanpansuipian2_7.png",
                    "yuanpansuipian2_8.png",
                    "yuanpansuipian2_9.png"
                )], [1, "other", table(
                    35,
                    9,
                    115,
                    0.5,
                    0.85,
                    0.68,
                    345,
                    437,
                    644,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])],
        [1, 9, table([1, "random", table([1, "plists", table(
                    "gaizisuipian_1.png",
                    "gaizisuipian_2.png",
                    "gaizisuipian_3.png",
                    "gaizisuipian_4.png",
                    "gaizisuipian_5.png",
                    "gaizisuipian_6.png",
                    "gaizisuipian_7.png"
                )], [1, "other", table(
                    30,
                    18,
                    101,
                    0.5,
                    0.85,
                    0.64,
                    345,
                    437,
                    644,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])],
        [1, 8, table([1, "fix", table(
                [1, "plists", table(
                    "dsp_1.png",
                    "dsp_2.png",
                    "dsp_3.png",
                    "dsp_4.png",
                    "dsp_10.png",
                    "dsp_11.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-53, -61)],
                    [0, cc.p(61, -53)],
                    [0, cc.p(79, 61)],
                    [0, cc.p(-53, 61)],
                    [0, cc.p(-79, 9)],
                    [0, cc.p(17.5, 53)]
                )],
                [1, "angle", table(
                    [0, cc.p(270, 450)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(90, 270)]
                )],
                [1, "other", table(
                    23,
                    124,
                    0.64,
                    184,
                    299,
                    690,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "dsp_6.png",
                    "dsp_7.png",
                    "dsp_8.png",
                    "dsp_9.png",
                    "dsp_12.png",
                    "dsp_13.png",
                    "dsp_14.png"
                )], [1, "other", table(
                    35,
                    46,
                    101,
                    0.5,
                    0.85,
                    0.68,
                    345,
                    437,
                    644,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "xiangzisuipian_1.png",
                    "xiangzisuipian_2.png",
                    "xiangzisuipian_3.png",
                    "xiangzisuipian_4.png",
                    "xiangzisuipian_6.png",
                    "xiangzisuipian_7.png",
                    "xiangzisuipian_8.png",
                    "xiangzisuipian_9.png",
                    "xiangzisuipian_11.png",
                    "xiangzisuipian_14.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-53, 70)],
                    [0, cc.p(0, 70)],
                    [0, cc.p(79, 61)],
                    [0, cc.p(61, -61)],
                    [0, cc.p(-61, -70)],
                    [0, cc.p(9, -70)],
                    [0, cc.p(79, 0)],
                    [0, cc.p(-79, 26)],
                    [0, cc.p(26, 26)],
                    [0, cc.p(9, -9)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)]
                )],
                [1, "other", table(
                    69,
                    138,
                    0.7,
                    207,
                    345,
                    690,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "xiangzisuipian_5.png",
                    "xiangzisuipian_10.png",
                    "xiangzisuipian_12.png",
                    "xiangzisuipian_13.png"
                )], [1, "other", table(
                    45,
                    18,
                    101,
                    0.3,
                    1,
                    0.7,
                    345,
                    437,
                    644,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])]
    )]
)
ParticleAnimationConfig.icepopboxFlakeFixPosConfig = table(
    [0, table(
        [1, 12, table([1, "fix", table(
                [1, "plists", table("gai_01.png", "gai_02.png")],
                [1, "pos", table([0, cc.p(-54, 0)], [0, cc.p(54, 0)])],
                [1, "angle", table([0, cc.p(90, 270)], [0, cc.p(270, 450)])],
                [1, "other", table(
                    232,
                    232,
                    0.23,
                    540,
                    696,
                    1120,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table("gai_12.png")], [1, "other", table(
                    20,
                    96,
                    192,
                    0.4,
                    0.6,
                    0.25,
                    386,
                    618,
                    1546,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])],
        [1, 11, table([1, "fix", table(
                [1, "plists", table(
                    "gai_06.png",
                    "gai_03.png",
                    "gai_05.png",
                    "gai_04.png",
                    "gai_09.png",
                    "gai_15.png",
                    "gai_14.png",
                    "gai_16.png",
                    "gai_17.png",
                    "gai_19.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-38, 43)],
                    [0, cc.p(36, 33)],
                    [0, cc.p(-38, -45)],
                    [0, cc.p(37, -40)],
                    [0, cc.p(5, -4)],
                    [0, cc.p(-27, -2)],
                    [0, cc.p(7, 42)],
                    [0, cc.p(-53, 18)],
                    [0, cc.p(-6, 42)],
                    [0, cc.p(3, 4)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)]
                )],
                [1, "other", table(
                    139,
                    247,
                    0.23,
                    540,
                    772,
                    1816,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "gai_11.png",
                    "gai_08.png",
                    "gai_12.png",
                    "gai_13.png",
                    "gai_07.png"
                )], [1, "other", table(
                    13,
                    96,
                    192,
                    0.7,
                    0.9,
                    0.25,
                    386,
                    618,
                    1700,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])],
        [1, 10, table([1, "fix", table(
                [1, "plists", table("binggun_01.png")],
                [1, "pos", table([0, cc.p(0, -18)])],
                [1, "angle", table([0, cc.p(60, 120)])],
                [1, "other", table(
                    154,
                    255,
                    0.25,
                    540,
                    772,
                    1352,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "binggun_02.png",
                    "binggun_03.png",
                    "binggun_04.png",
                    "binggun_05.png",
                    "binggun_06.png"
                )], [1, "other", table(
                    14,
                    92,
                    215,
                    0.4,
                    1.8,
                    0.24,
                    696,
                    928,
                    1778,
                    80,
                    15,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "hezi_01.png",
                    "hezi_02.png",
                    "hezi_03.png",
                    "hezi_04.png",
                    "hezi_06.png",
                    "hezi_09.png",
                    "hezi_10.png",
                    "hezi_12.png",
                    "hezi_13.png",
                    "hezi_12.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-51, 48)],
                    [0, cc.p(0, 61)],
                    [0, cc.p(51, 50)],
                    [0, cc.p(54, -8)],
                    [0, cc.p(49, -52)],
                    [0, cc.p(-50, -50)],
                    [0, cc.p(0, -62)],
                    [0, cc.p(22, -43)],
                    [0, cc.p(-42, -34)],
                    [0, cc.p(0, 12)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 135)],
                    [0, cc.p(45, 90)],
                    [0, cc.p(0, 90)],
                    [0, cc.p(270, 360)],
                    [0, cc.p(315, 405)],
                    [0, cc.p(0, 90)],
                    [0, cc.p(270, 360)],
                    [0, cc.p(315, 405)],
                    [0, cc.p(0, 90)],
                    [0, cc.p(0, 90)]
                )],
                [1, "other", table(
                    171,
                    339,
                    0.25,
                    772,
                    1082,
                    1430,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "hezi_08.png",
                    "hezi_11.png",
                    "hezi_05.png",
                    "hezi_07.png"
                )], [1, "other", table(
                    16,
                    96,
                    192,
                    1,
                    1.2,
                    0.25,
                    464,
                    618,
                    1430,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])]
    )],
    [0, table(
        [1, 12, table([1, "fix", table(
                [1, "plists", table("gai_01.png", "gai_02.png")],
                [1, "pos", table([0, cc.p(-54, 0)], [0, cc.p(54, 0)])],
                [1, "angle", table([0, cc.p(90, 270)], [0, cc.p(270, 450)])],
                [1, "other", table(
                    162,
                    162,
                    0.32,
                    378,
                    487,
                    784,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table("gai_12.png")], [1, "other", table(
                    20,
                    83.3,
                    134.4,
                    0.4,
                    0.6,
                    0.35,
                    270,
                    432,
                    1082,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])],
        [1, 11, table([1, "fix", table(
                [1, "plists", table(
                    "gai_06.png",
                    "gai_03.png",
                    "gai_05.png",
                    "gai_04.png",
                    "gai_09.png",
                    "gai_15.png",
                    "gai_14.png",
                    "gai_16.png",
                    "gai_17.png",
                    "gai_19.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-38, 43)],
                    [0, cc.p(36, 33)],
                    [0, cc.p(-38, -45)],
                    [0, cc.p(37, -40)],
                    [0, cc.p(5, -4)],
                    [0, cc.p(-27, -2)],
                    [0, cc.p(7, 42)],
                    [0, cc.p(-53, 18)],
                    [0, cc.p(-6, 42)],
                    [0, cc.p(3, 4)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)]
                )],
                [1, "other", table(
                    97,
                    173,
                    0.32,
                    378,
                    540,
                    1271,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "gai_11.png",
                    "gai_08.png",
                    "gai_12.png",
                    "gai_13.png",
                    "gai_07.png"
                )], [1, "other", table(
                    13,
                    67,
                    134,
                    0.7,
                    0.9,
                    0.35,
                    270,
                    432,
                    1190,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])],
        [1, 10, table([1, "fix", table(
                [1, "plists", table("binggun_01.png")],
                [1, "pos", table([0, cc.p(0, -18)])],
                [1, "angle", table([0, cc.p(60, 120)])],
                [1, "other", table(
                    108,
                    179,
                    0.35,
                    378,
                    540,
                    946,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "binggun_02.png",
                    "binggun_03.png",
                    "binggun_04.png",
                    "binggun_05.png",
                    "binggun_06.png"
                )], [1, "other", table(
                    14,
                    64.4,
                    151,
                    0.4,
                    1.8,
                    0.34,
                    487,
                    650,
                    1245,
                    80,
                    15,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "hezi_01.png",
                    "hezi_02.png",
                    "hezi_03.png",
                    "hezi_04.png",
                    "hezi_06.png",
                    "hezi_09.png",
                    "hezi_10.png",
                    "hezi_12.png",
                    "hezi_13.png",
                    "hezi_12.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-51, 48)],
                    [0, cc.p(0, 61)],
                    [0, cc.p(51, 50)],
                    [0, cc.p(54, -8)],
                    [0, cc.p(49, -52)],
                    [0, cc.p(-50, -50)],
                    [0, cc.p(0, -62)],
                    [0, cc.p(22, -43)],
                    [0, cc.p(-42, -34)],
                    [0, cc.p(0, 12)]
                )],
                [1, "angle", table(
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(0, 90)]
                )],
                [1, "other", table(
                    120,
                    237.3,
                    0.36,
                    540,
                    757.4,
                    1001,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "hezi_08.png",
                    "hezi_11.png",
                    "hezi_05.png",
                    "hezi_07.png"
                )], [1, "other", table(
                    16,
                    67.2,
                    134.4,
                    1,
                    1.2,
                    0.36,
                    324.8,
                    432.6,
                    1001,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])]
    )],
    [0, table(
        [1, 12, table([1, "fix", table(
                [1, "plists", table("gai_01.png", "gai_02.png")],
                [1, "pos", table([0, cc.p(-54, 0)], [0, cc.p(54, 0)])],
                [1, "angle", table([0, cc.p(90, 270)], [0, cc.p(270, 450)])],
                [1, "other", table(
                    127.6,
                    127.6,
                    0.42,
                    297,
                    383,
                    616,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table("gai_12.png")], [1, "other", table(
                    20,
                    52.8,
                    105.6,
                    0.4,
                    0.6,
                    0.45,
                    212,
                    340,
                    850.3,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])],
        [1, 11, table([1, "fix", table(
                [1, "plists", table(
                    "gai_06.png",
                    "gai_03.png",
                    "gai_05.png",
                    "gai_04.png",
                    "gai_09.png",
                    "gai_15.png",
                    "gai_14.png",
                    "gai_16.png",
                    "gai_17.png",
                    "gai_19.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-38, 43)],
                    [0, cc.p(36, 33)],
                    [0, cc.p(-38, -45)],
                    [0, cc.p(37, -40)],
                    [0, cc.p(5, -4)],
                    [0, cc.p(-27, -2)],
                    [0, cc.p(7, 42)],
                    [0, cc.p(-53, 18)],
                    [0, cc.p(-6, 42)],
                    [0, cc.p(3, 4)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)]
                )],
                [1, "other", table(
                    76.4,
                    135.8,
                    0.42,
                    297,
                    425,
                    999,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "gai_11.png",
                    "gai_08.png",
                    "gai_12.png",
                    "gai_13.png",
                    "gai_07.png"
                )], [1, "other", table(
                    13,
                    52.8,
                    105.6,
                    1,
                    1.2,
                    0.45,
                    212,
                    340,
                    935,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])],
        [1, 10, table([1, "fix", table(
                [1, "plists", table("binggun_01.png")],
                [1, "pos", table([0, cc.p(0, -18)])],
                [1, "angle", table([0, cc.p(60, 120)])],
                [1, "other", table(
                    84.7,
                    140,
                    0.45,
                    297,
                    424.6,
                    743.6,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "binggun_02.png",
                    "binggun_03.png",
                    "binggun_04.png",
                    "binggun_05.png",
                    "binggun_06.png"
                )], [1, "other", table(
                    14,
                    50.6,
                    118,
                    0.4,
                    1.8,
                    0.44,
                    383,
                    510,
                    978,
                    80,
                    15,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "hezi_01.png",
                    "hezi_02.png",
                    "hezi_03.png",
                    "hezi_04.png",
                    "hezi_06.png",
                    "hezi_09.png",
                    "hezi_10.png",
                    "hezi_12.png",
                    "hezi_13.png",
                    "hezi_12.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-51, 48)],
                    [0, cc.p(0, 61)],
                    [0, cc.p(51, 50)],
                    [0, cc.p(54, -8)],
                    [0, cc.p(49, -52)],
                    [0, cc.p(-50, -50)],
                    [0, cc.p(0, -62)],
                    [0, cc.p(22, -43)],
                    [0, cc.p(-42, -34)],
                    [0, cc.p(0, 12)]
                )],
                [1, "angle", table(
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(0, 90)]
                )],
                [1, "other", table(
                    94,
                    186,
                    0.45,
                    424.6,
                    595,
                    787,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "hezi_08.png",
                    "hezi_11.png",
                    "hezi_05.png",
                    "hezi_07.png"
                )], [1, "other", table(
                    11,
                    52.8,
                    105.6,
                    1,
                    1.2,
                    0.45,
                    255,
                    340,
                    787,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])]
    )],
    [0, table(
        [1, 12, table([1, "fix", table(
                [1, "plists", table("gai_01.png", "gai_02.png")],
                [1, "pos", table([0, cc.p(-54, 0)], [0, cc.p(54, 0)])],
                [1, "angle", table([0, cc.p(90, 270)], [0, cc.p(270, 450)])],
                [1, "other", table(
                    106.7,
                    106.7,
                    0.5,
                    248,
                    320,
                    515,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table("gai_12.png")], [1, "other", table(
                    20,
                    44,
                    88,
                    0.4,
                    0.6,
                    0.54,
                    177.6,
                    284,
                    711,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])],
        [1, 11, table([1, "fix", table(
                [1, "plists", table(
                    "gai_06.png",
                    "gai_03.png",
                    "gai_05.png",
                    "gai_04.png",
                    "gai_09.png",
                    "gai_15.png",
                    "gai_14.png",
                    "gai_16.png",
                    "gai_17.png",
                    "gai_19.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-38, 43)],
                    [0, cc.p(36, 33)],
                    [0, cc.p(-38, -45)],
                    [0, cc.p(37, -40)],
                    [0, cc.p(5, -4)],
                    [0, cc.p(-27, -2)],
                    [0, cc.p(7, 42)],
                    [0, cc.p(-53, 18)],
                    [0, cc.p(-6, 42)],
                    [0, cc.p(3, 4)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)]
                )],
                [1, "other", table(
                    64,
                    114,
                    0.5,
                    284,
                    355,
                    835,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "gai_11.png",
                    "gai_08.png",
                    "gai_12.png",
                    "gai_13.png",
                    "gai_07.png"
                )], [1, "other", table(
                    13,
                    44,
                    88,
                    0.7,
                    0.9,
                    0.54,
                    177.6,
                    284,
                    782,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])],
        [1, 10, table([1, "fix", table(
                [1, "plists", table("binggun_01.png")],
                [1, "pos", table([0, cc.p(0, -18)])],
                [1, "angle", table([0, cc.p(60, 120)])],
                [1, "other", table(
                    70.8,
                    117,
                    0.54,
                    248,
                    355,
                    622,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "binggun_02.png",
                    "binggun_03.png",
                    "binggun_04.png",
                    "binggun_05.png",
                    "binggun_06.png"
                )], [1, "other", table(
                    14,
                    42,
                    99,
                    0.4,
                    1.8,
                    0.52,
                    320,
                    427,
                    818,
                    80,
                    15,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "hezi_01.png",
                    "hezi_02.png",
                    "hezi_03.png",
                    "hezi_04.png",
                    "hezi_06.png",
                    "hezi_09.png",
                    "hezi_10.png",
                    "hezi_12.png",
                    "hezi_13.png",
                    "hezi_12.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-51, 48)],
                    [0, cc.p(0, 61)],
                    [0, cc.p(51, 50)],
                    [0, cc.p(54, -8)],
                    [0, cc.p(49, -52)],
                    [0, cc.p(-50, -50)],
                    [0, cc.p(0, -62)],
                    [0, cc.p(22, -43)],
                    [0, cc.p(-42, -34)],
                    [0, cc.p(0, 12)]
                )],
                [1, "angle", table(
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(90, 270)],
                    [0, cc.p(270, 450)],
                    [0, cc.p(0, 90)]
                )],
                [1, "other", table(
                    78,
                    156,
                    0.54,
                    355,
                    498,
                    658,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "hezi_08.png",
                    "hezi_11.png",
                    "hezi_05.png",
                    "hezi_07.png"
                )], [1, "other", table(
                    16,
                    44,
                    88,
                    1,
                    1.2,
                    0.54,
                    213,
                    284,
                    658,
                    80,
                    15,
                    [0, table([1, "square", 140])]
                )])])]
    )]
)
ParticleAnimationConfig.foambombFlakeConfig = table(
    [0, table(
        [1, 6, table([1, "fix", table(
                [1, "plists", table(
                    "suipian2_7.png",
                    "suipian2_8.png",
                    "suipian2_9.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    78,
                    385,
                    0.1,
                    600,
                    785,
                    1550,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "suipian2_1.png",
                    "suipian2_2.png",
                    "suipian2_3.png",
                    "suipian2_4.png",
                    "suipian2_5.png",
                    "suipian2_6.png"
                )], [1, "other", table(
                    12,
                    57,
                    228,
                    0.8,
                    1.5,
                    0.21,
                    314,
                    648,
                    1550,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 5, table([1, "fix", table(
                [1, "plists", table(
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_5.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    78,
                    385,
                    0.1,
                    600,
                    785,
                    1550,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png",
                    "suipian1_5.png",
                    "suipian1_6.png",
                    "suipian1_7.png"
                )], [1, "other", table(
                    6,
                    57,
                    228,
                    0.8,
                    1.5,
                    0.21,
                    314,
                    648,
                    1550,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 4, table([1, "fix", table(
                [1, "plists", table(
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png",
                    "suipian1_5.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    78,
                    385,
                    0.1,
                    600,
                    785,
                    1550,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png",
                    "suipian1_5.png",
                    "suipian1_6.png",
                    "suipian1_7.png"
                )], [1, "other", table(
                    10,
                    57,
                    228,
                    0.8,
                    1.5,
                    0.21,
                    314,
                    648,
                    1550,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 3, table([1, "fix", table(
                [1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    78,
                    385,
                    0.1,
                    600,
                    785,
                    1550,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png",
                    "suipian1_5.png",
                    "suipian1_6.png",
                    "suipian1_7.png"
                )], [1, "other", table(
                    10,
                    57,
                    228,
                    0.8,
                    1.5,
                    0.21,
                    314,
                    648,
                    1550,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "fix", table(
                [1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    78,
                    385,
                    0.1,
                    600,
                    785,
                    1550,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png",
                    "suipian1_5.png",
                    "suipian1_6.png",
                    "suipian1_7.png"
                )], [1, "other", table(
                    8,
                    57,
                    228,
                    0.8,
                    1.5,
                    0.21,
                    314,
                    648,
                    1550,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    78,
                    385,
                    0.1,
                    600,
                    785,
                    1550,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png",
                    "suipian1_5.png",
                    "suipian1_6.png",
                    "suipian1_7.png",
                    "suipian1_7.png"
                )], [1, "other", table(
                    10,
                    57,
                    228,
                    0.8,
                    1.5,
                    0.21,
                    314,
                    648,
                    1550,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])]
    )],
    [0, table(
        [1, 6, table([1, "fix", table(
                [1, "plists", table(
                    "suipian2_7.png",
                    "suipian2_8.png",
                    "suipian2_9.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    55,
                    270,
                    0.1,
                    420,
                    785,
                    550,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png",
                    "suipian1_5.png",
                    "suipian1_6.png",
                    "suipian1_7.png"
                )], [1, "other", table(
                    12,
                    40,
                    160,
                    0.8,
                    1.5,
                    0.21,
                    220,
                    454,
                    1085,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 5, table([1, "fix", table(
                [1, "plists", table(
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_5.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    55,
                    270,
                    0.1,
                    420,
                    785,
                    550,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png",
                    "suipian1_5.png",
                    "suipian1_6.png",
                    "suipian1_7.png"
                )], [1, "other", table(
                    6,
                    57,
                    228,
                    0.8,
                    1.5,
                    0.21,
                    314,
                    648,
                    1550,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 4, table([1, "fix", table(
                [1, "plists", table(
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png",
                    "suipian1_5.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    55,
                    270,
                    0.1,
                    420,
                    785,
                    550,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png",
                    "suipian1_5.png",
                    "suipian1_6.png",
                    "suipian1_7.png"
                )], [1, "other", table(
                    10,
                    40,
                    160,
                    0.8,
                    1.5,
                    0.21,
                    220,
                    454,
                    1085,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 3, table([1, "fix", table(
                [1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    55,
                    270,
                    0.1,
                    420,
                    785,
                    550,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png",
                    "suipian1_5.png",
                    "suipian1_6.png",
                    "suipian1_7.png"
                )], [1, "other", table(
                    10,
                    40,
                    160,
                    0.8,
                    1.5,
                    0.21,
                    220,
                    454,
                    1085,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "fix", table(
                [1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    55,
                    270,
                    0.1,
                    420,
                    785,
                    550,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png",
                    "suipian1_5.png",
                    "suipian1_6.png",
                    "suipian1_7.png"
                )], [1, "other", table(
                    8,
                    40,
                    160,
                    0.8,
                    1.5,
                    0.21,
                    220,
                    454,
                    1085,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    55,
                    270,
                    0.1,
                    420,
                    785,
                    550,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png",
                    "suipian1_5.png",
                    "suipian1_6.png",
                    "suipian1_7.png"
                )], [1, "other", table(
                    10,
                    40,
                    160,
                    0.8,
                    1.5,
                    0.21,
                    220,
                    454,
                    1085,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])]
    )],
    [0, table(
        [1, 6, table([1, "fix", table(
                [1, "plists", table(
                    "suipian2_7.png",
                    "suipian2_8.png",
                    "suipian2_9.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    43,
                    212,
                    0.1,
                    330,
                    432,
                    853,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png",
                    "suipian1_5.png",
                    "suipian1_6.png",
                    "suipian1_7.png"
                )], [1, "other", table(
                    12,
                    31,
                    125,
                    0.8,
                    1.5,
                    0.21,
                    173,
                    356,
                    853,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 5, table([1, "fix", table(
                [1, "plists", table(
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_5.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    43,
                    212,
                    0.1,
                    330,
                    432,
                    853,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png",
                    "suipian1_5.png",
                    "suipian1_6.png",
                    "suipian1_7.png"
                )], [1, "other", table(
                    6,
                    31,
                    125,
                    0.8,
                    1.5,
                    0.21,
                    173,
                    356,
                    853,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 4, table([1, "fix", table(
                [1, "plists", table(
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png",
                    "suipian1_5.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    43,
                    212,
                    0.1,
                    330,
                    432,
                    853,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png",
                    "suipian1_5.png",
                    "suipian1_6.png",
                    "suipian1_7.png"
                )], [1, "other", table(
                    10,
                    31,
                    125,
                    0.8,
                    1.5,
                    0.21,
                    173,
                    356,
                    853,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 3, table([1, "fix", table(
                [1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    43,
                    212,
                    0.1,
                    330,
                    432,
                    853,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png",
                    "suipian1_5.png",
                    "suipian1_6.png",
                    "suipian1_7.png"
                )], [1, "other", table(
                    10,
                    31,
                    125,
                    0.8,
                    1.5,
                    0.21,
                    173,
                    356,
                    853,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "fix", table(
                [1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    43,
                    212,
                    0.1,
                    330,
                    432,
                    853,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png",
                    "suipian1_5.png",
                    "suipian1_6.png",
                    "suipian1_7.png"
                )], [1, "other", table(
                    8,
                    31,
                    125,
                    0.8,
                    1.5,
                    0.21,
                    173,
                    356,
                    853,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    43,
                    212,
                    0.1,
                    330,
                    432,
                    853,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png",
                    "suipian1_5.png",
                    "suipian1_6.png",
                    "suipian1_7.png"
                )], [1, "other", table(
                    10,
                    31,
                    125,
                    0.8,
                    1.5,
                    0.21,
                    173,
                    356,
                    853,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])]
    )],
    [0, table(
        [1, 6, table([1, "fix", table(
                [1, "plists", table(
                    "suipian2_7.png",
                    "suipian2_8.png",
                    "suipian2_9.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    36,
                    177,
                    0.1,
                    276,
                    361,
                    713,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png",
                    "suipian1_5.png",
                    "suipian1_6.png",
                    "suipian1_7.png"
                )], [1, "other", table(
                    12,
                    26,
                    105,
                    0.8,
                    1.5,
                    0.21,
                    144,
                    298,
                    713,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 5, table([1, "fix", table(
                [1, "plists", table(
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_5.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    36,
                    177,
                    0.1,
                    276,
                    361,
                    713,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png",
                    "suipian1_5.png",
                    "suipian1_6.png",
                    "suipian1_7.png"
                )], [1, "other", table(
                    6,
                    26,
                    105,
                    0.8,
                    1.5,
                    0.21,
                    144,
                    298,
                    713,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 4, table([1, "fix", table(
                [1, "plists", table(
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png",
                    "suipian1_5.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    36,
                    177,
                    0.1,
                    276,
                    361,
                    713,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png",
                    "suipian1_5.png",
                    "suipian1_6.png",
                    "suipian1_7.png"
                )], [1, "other", table(
                    10,
                    26,
                    105,
                    0.8,
                    1.5,
                    0.21,
                    144,
                    298,
                    713,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 3, table([1, "fix", table(
                [1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    36,
                    177,
                    0.1,
                    276,
                    361,
                    713,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png",
                    "suipian1_5.png",
                    "suipian1_6.png",
                    "suipian1_7.png"
                )], [1, "other", table(
                    10,
                    26,
                    105,
                    0.8,
                    1.5,
                    0.21,
                    144,
                    298,
                    713,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "fix", table(
                [1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    36,
                    177,
                    0.1,
                    276,
                    361,
                    713,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png",
                    "suipian1_5.png",
                    "suipian1_6.png",
                    "suipian1_7.png"
                )], [1, "other", table(
                    8,
                    26,
                    105,
                    0.8,
                    1.5,
                    0.21,
                    144,
                    298,
                    713,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    36,
                    177,
                    0.1,
                    276,
                    361,
                    713,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "suipian1_1.png",
                    "suipian1_2.png",
                    "suipian1_3.png",
                    "suipian1_4.png",
                    "suipian1_5.png",
                    "suipian1_6.png",
                    "suipian1_7.png"
                )], [1, "other", table(
                    10,
                    26,
                    105,
                    0.8,
                    1.5,
                    0.21,
                    144,
                    298,
                    713,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])]
    )]
)
ParticleAnimationConfig.VarSnowFlakeFixPosConfig = table(
    [0, table(
        [1, 5, table([1, "fix", table(
                [1, "plists", table(
                    "04_l.png",
                    "04_k.png",
                    "04_j.png",
                    "04_i.png",
                    "04_h.png"
                )],
                [1, "pos", table(
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    55,
                    315,
                    0.1,
                    600,
                    785,
                    1350,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_1.png",
                    "ice_2.png",
                    "ice_3.png",
                    "ice_4.png",
                    "ice_5.png",
                    "ice_6.png",
                    "ice_7.png",
                    "ice_8.png",
                    "ice_9.png",
                    "ice_10.png"
                )], [1, "other", table(
                    6,
                    50,
                    208,
                    0.5,
                    0.8,
                    0.21,
                    314,
                    648,
                    1350,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 4, table([1, "fix", table(
                [1, "plists", table(
                    "03_k.png",
                    "03_j.png",
                    "03_i.png",
                    "03_h.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    55,
                    315,
                    0.1,
                    600,
                    785,
                    1350,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_1.png",
                    "ice_2.png",
                    "ice_3.png",
                    "ice_4.png",
                    "ice_5.png",
                    "ice_6.png",
                    "ice_7.png",
                    "ice_8.png",
                    "ice_9.png",
                    "ice_10.png"
                )], [1, "other", table(
                    6,
                    50,
                    208,
                    0.5,
                    0.8,
                    0.21,
                    314,
                    648,
                    1350,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 3, table([1, "fix", table(
                [1, "plists", table(
                    "02_k.png",
                    "02_j.png",
                    "02_i.png",
                    "02_h.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    55,
                    315,
                    0.1,
                    600,
                    785,
                    1350,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_1.png",
                    "ice_2.png",
                    "ice_3.png",
                    "ice_4.png",
                    "ice_5.png",
                    "ice_6.png",
                    "ice_7.png",
                    "ice_8.png",
                    "ice_9.png",
                    "ice_10.png"
                )], [1, "other", table(
                    6,
                    50,
                    208,
                    0.5,
                    0.8,
                    0.21,
                    314,
                    648,
                    1350,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "fix", table(
                [1, "plists", table(
                    "01_n.png",
                    "01_m.png",
                    "01_k.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    55,
                    315,
                    0.1,
                    600,
                    785,
                    1350,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_1.png",
                    "ice_2.png",
                    "ice_3.png",
                    "ice_4.png",
                    "ice_5.png",
                    "ice_6.png",
                    "ice_7.png",
                    "ice_8.png",
                    "ice_9.png",
                    "ice_10.png"
                )], [1, "other", table(
                    6,
                    50,
                    208,
                    0.5,
                    0.8,
                    0.21,
                    314,
                    648,
                    1350,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "ice_01.png",
                    "ice_02.png",
                    "ice_03.png",
                    "ice_04.png",
                    "ice_05.png",
                    "ice_06.png",
                    "ice_07.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    55,
                    315,
                    0.1,
                    600,
                    785,
                    1350,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_1.png",
                    "ice_2.png",
                    "ice_3.png",
                    "ice_4.png",
                    "ice_5.png",
                    "ice_6.png",
                    "ice_7.png",
                    "ice_8.png",
                    "ice_9.png",
                    "ice_10.png"
                )], [1, "other", table(
                    6,
                    50,
                    208,
                    0.5,
                    0.8,
                    0.21,
                    314,
                    648,
                    1350,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])]
    )],
    [0, table(
        [1, 5, table([1, "fix", table(
                [1, "plists", table(
                    "04_l.png",
                    "04_k.png",
                    "04_j.png",
                    "04_i.png",
                    "04_h.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    39,
                    221,
                    0.1,
                    420,
                    550,
                    945,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_1.png",
                    "ice_2.png",
                    "ice_3.png",
                    "ice_4.png",
                    "ice_5.png",
                    "ice_6.png",
                    "ice_7.png",
                    "ice_8.png",
                    "ice_9.png",
                    "ice_10.png"
                )], [1, "other", table(
                    6,
                    35,
                    146,
                    0.5,
                    0.8,
                    0.21,
                    220,
                    454,
                    945,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 4, table([1, "fix", table(
                [1, "plists", table(
                    "03_k.png",
                    "03_j.png",
                    "03_i.png",
                    "03_h.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    39,
                    221,
                    0.1,
                    420,
                    550,
                    945,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_1.png",
                    "ice_2.png",
                    "ice_3.png",
                    "ice_4.png",
                    "ice_5.png",
                    "ice_6.png",
                    "ice_7.png",
                    "ice_8.png",
                    "ice_9.png",
                    "ice_10.png"
                )], [1, "other", table(
                    6,
                    35,
                    146,
                    0.5,
                    0.8,
                    0.21,
                    220,
                    454,
                    945,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 3, table([1, "fix", table(
                [1, "plists", table(
                    "02_k.png",
                    "02_j.png",
                    "02_i.png",
                    "02_h.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    39,
                    221,
                    0.1,
                    420,
                    550,
                    945,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_1.png",
                    "ice_2.png",
                    "ice_3.png",
                    "ice_4.png",
                    "ice_5.png",
                    "ice_6.png",
                    "ice_7.png",
                    "ice_8.png",
                    "ice_9.png",
                    "ice_10.png"
                )], [1, "other", table(
                    6,
                    35,
                    146,
                    0.5,
                    0.8,
                    0.21,
                    220,
                    454,
                    945,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "fix", table(
                [1, "plists", table(
                    "01_n.png",
                    "01_m.png",
                    "01_k.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    39,
                    221,
                    0.1,
                    420,
                    550,
                    945,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_1.png",
                    "ice_2.png",
                    "ice_3.png",
                    "ice_4.png",
                    "ice_5.png",
                    "ice_6.png",
                    "ice_7.png",
                    "ice_8.png",
                    "ice_9.png",
                    "ice_10.png"
                )], [1, "other", table(
                    6,
                    35,
                    146,
                    0.5,
                    0.8,
                    0.21,
                    220,
                    454,
                    945,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "ice_01.png",
                    "ice_02.png",
                    "ice_03.png",
                    "ice_04.png",
                    "ice_05.png",
                    "ice_06.png",
                    "ice_07.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    39,
                    221,
                    0.1,
                    420,
                    550,
                    945,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_1.png",
                    "ice_2.png",
                    "ice_3.png",
                    "ice_4.png",
                    "ice_5.png",
                    "ice_6.png",
                    "ice_7.png",
                    "ice_8.png",
                    "ice_9.png",
                    "ice_10.png"
                )], [1, "other", table(
                    6,
                    35,
                    146,
                    0.5,
                    0.8,
                    0.21,
                    220,
                    454,
                    945,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])]
    )],
    [0, table(
        [1, 5, table([1, "fix", table(
                [1, "plists", table(
                    "04_l.png",
                    "04_k.png",
                    "04_j.png",
                    "04_i.png",
                    "04_h.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    30,
                    173,
                    0.1,
                    330,
                    432,
                    743,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_1.png",
                    "ice_2.png",
                    "ice_3.png",
                    "ice_4.png",
                    "ice_5.png",
                    "ice_6.png",
                    "ice_7.png",
                    "ice_8.png",
                    "ice_9.png",
                    "ice_10.png"
                )], [1, "other", table(
                    6,
                    28,
                    114,
                    0.5,
                    0.8,
                    0.21,
                    173,
                    356,
                    743,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 4, table([1, "fix", table(
                [1, "plists", table(
                    "03_k.png",
                    "03_j.png",
                    "03_i.png",
                    "03_h.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    30,
                    173,
                    0.1,
                    330,
                    432,
                    743,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_1.png",
                    "ice_2.png",
                    "ice_3.png",
                    "ice_4.png",
                    "ice_5.png",
                    "ice_6.png",
                    "ice_7.png",
                    "ice_8.png",
                    "ice_9.png",
                    "ice_10.png"
                )], [1, "other", table(
                    6,
                    28,
                    114,
                    0.5,
                    0.8,
                    0.21,
                    173,
                    356,
                    743,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 3, table([1, "fix", table(
                [1, "plists", table(
                    "02_k.png",
                    "02_j.png",
                    "02_i.png",
                    "02_h.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    30,
                    173,
                    0.1,
                    330,
                    432,
                    743,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_1.png",
                    "ice_2.png",
                    "ice_3.png",
                    "ice_4.png",
                    "ice_5.png",
                    "ice_6.png",
                    "ice_7.png",
                    "ice_8.png",
                    "ice_9.png",
                    "ice_10.png"
                )], [1, "other", table(
                    6,
                    28,
                    114,
                    0.5,
                    0.8,
                    0.21,
                    173,
                    356,
                    743,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "fix", table(
                [1, "plists", table(
                    "01_n.png",
                    "01_m.png",
                    "01_k.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    30,
                    173,
                    0.1,
                    330,
                    432,
                    743,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_1.png",
                    "ice_2.png",
                    "ice_3.png",
                    "ice_4.png",
                    "ice_5.png",
                    "ice_6.png",
                    "ice_7.png",
                    "ice_8.png",
                    "ice_9.png",
                    "ice_10.png"
                )], [1, "other", table(
                    6,
                    28,
                    114,
                    0.5,
                    0.8,
                    0.21,
                    173,
                    356,
                    743,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "ice_01.png",
                    "ice_02.png",
                    "ice_03.png",
                    "ice_04.png",
                    "ice_05.png",
                    "ice_06.png",
                    "ice_07.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    30,
                    173,
                    0.1,
                    330,
                    432,
                    743,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_1.png",
                    "ice_2.png",
                    "ice_3.png",
                    "ice_4.png",
                    "ice_5.png",
                    "ice_6.png",
                    "ice_7.png",
                    "ice_8.png",
                    "ice_9.png",
                    "ice_10.png"
                )], [1, "other", table(
                    6,
                    28,
                    114,
                    0.5,
                    0.8,
                    0.21,
                    173,
                    356,
                    743,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])]
    )],
    [0, table(
        [1, 5, table([1, "fix", table(
                [1, "plists", table(
                    "04_l.png",
                    "04_k.png",
                    "04_j.png",
                    "04_i.png",
                    "04_h.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    25,
                    145,
                    0.1,
                    276,
                    361,
                    621,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_1.png",
                    "ice_2.png",
                    "ice_3.png",
                    "ice_4.png",
                    "ice_5.png",
                    "ice_6.png",
                    "ice_7.png",
                    "ice_8.png",
                    "ice_9.png",
                    "ice_10.png"
                )], [1, "other", table(
                    6,
                    23,
                    96,
                    0.5,
                    0.8,
                    0.21,
                    144,
                    298,
                    621,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 4, table([1, "fix", table(
                [1, "plists", table(
                    "03_k.png",
                    "03_j.png",
                    "03_i.png",
                    "03_h.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    25,
                    145,
                    0.1,
                    276,
                    361,
                    621,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_1.png",
                    "ice_2.png",
                    "ice_3.png",
                    "ice_4.png",
                    "ice_5.png",
                    "ice_6.png",
                    "ice_7.png",
                    "ice_8.png",
                    "ice_9.png",
                    "ice_10.png"
                )], [1, "other", table(
                    6,
                    23,
                    96,
                    0.5,
                    0.8,
                    0.21,
                    144,
                    298,
                    621,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 3, table([1, "fix", table(
                [1, "plists", table(
                    "02_k.png",
                    "02_j.png",
                    "02_i.png",
                    "02_h.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    25,
                    145,
                    0.1,
                    276,
                    361,
                    621,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_1.png",
                    "ice_2.png",
                    "ice_3.png",
                    "ice_4.png",
                    "ice_5.png",
                    "ice_6.png",
                    "ice_7.png",
                    "ice_8.png",
                    "ice_9.png",
                    "ice_10.png"
                )], [1, "other", table(
                    6,
                    23,
                    96,
                    0.5,
                    0.8,
                    0.21,
                    144,
                    298,
                    621,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 2, table([1, "fix", table(
                [1, "plists", table(
                    "01_n.png",
                    "01_m.png",
                    "01_k.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    25,
                    145,
                    0.1,
                    276,
                    361,
                    621,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_1.png",
                    "ice_2.png",
                    "ice_3.png",
                    "ice_4.png",
                    "ice_5.png",
                    "ice_6.png",
                    "ice_7.png",
                    "ice_8.png",
                    "ice_9.png",
                    "ice_10.png"
                )], [1, "other", table(
                    6,
                    23,
                    96,
                    0.5,
                    0.8,
                    0.21,
                    144,
                    298,
                    621,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])],
        [1, 1, table([1, "fix", table(
                [1, "plists", table(
                    "ice_01.png",
                    "ice_02.png",
                    "ice_03.png",
                    "ice_04.png",
                    "ice_05.png",
                    "ice_06.png",
                    "ice_07.png"
                )],
                [1, "pos", table(
                    [0, cc.p(-25, 35)],
                    [0, cc.p(35, 35)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)],
                    [0, cc.p(0, 0)]
                )],
                [1, "angle", table(
                    [0, cc.p(90, 130)],
                    [0, cc.p(60, 90)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)],
                    [0, cc.p(60, 120)]
                )],
                [1, "other", table(
                    25,
                    145,
                    0.1,
                    276,
                    361,
                    621,
                    75,
                    10
                )]
            )], [1, "random", table([1, "plists", table(
                    "ice_1.png",
                    "ice_2.png",
                    "ice_3.png",
                    "ice_4.png",
                    "ice_5.png",
                    "ice_6.png",
                    "ice_7.png",
                    "ice_8.png",
                    "ice_9.png",
                    "ice_10.png"
                )], [1, "other", table(
                    6,
                    23,
                    96,
                    0.5,
                    0.8,
                    0.21,
                    144,
                    298,
                    621,
                    75,
                    10,
                    [0, table([1, "square", 40])]
                )])])]
    )]
)
